import React, { Fragment, useContext, useEffect, useState, useRef, useLayoutEffect } from "react";
import { AppContext } from "../../../../components/AppProvider";
import { _API, _CK, _R, _U } from "../../../../modules/utils";
import styled, { css } from "styled-components";
import cx from "classnames";
import swal from "sweetalert";
import { _CFG } from "../../../../modules/config";

import adminSurvey from "../../../../resources/console/images/icon/icon_admin_survey.svg";
import adminConsole from "../../../../resources/console/images/icon/icon_admin_console.svg";
import adminFmsMain from "../../../../resources/console/images/icon/icon_admin_fmsmain.svg";
import adminFmsBroad from "../../../../resources/console/images/icon/icon_admin_fmsbroad.svg";
import surveyArrow from "../../../../resources/console/images/icon/40.svg";
import consolePopupEdit from "../../../../resources/console/images/icon/survey_edit.svg";
import iconCopy from "../../../../resources/preReg/images/icon/copy.svg";
import LiveTvOutlinedIcon from "@mui/icons-material/LiveTvOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SearchIcon from "@mui/icons-material/Search";
import { Menu, MenuItem } from "@mui/material";
import { Modal2Base } from "../../../../components/UI/Modal";
import { ChannelStatusBadge, LiveChannelListItem } from "../../../../components/design-system/live-channel";
import controlPanelSharedStyle from "../../Common/controlPanelSharedStyle";
import ConsoleStreamStatusChart from "./ConsoleStreamStatusChart";
import LiveCaptionsPanel, { LiveCaptionsDetail } from "../../Common/LiveCaptionsPanel";
import { Button } from "react-bootstrap";

import useStore from "../../../../modules/utils/store";

const { CONTROL_PANEL_CONFIGS } = require("../../Common/controlPanelConfig");

const STREAMING_STATUS_LABEL = {
    READY: "READY",
    RESERVED: "RESERVED",
    LIVE: "LIVE",
    ENDED: "ENDED",
    SUSPENDED: "SUSPENDED",
};

const STREAMING_STATUS_COLOR = {
    READY: "#22C55E",
    RESERVED: "#3B82F6",
    LIVE: "#EF4444",
    ENDED: "#94A3B8",
    SUSPENDED: "#F59E0B",
};

// API 응답 채널 → 사이드바 표시용 형태로 변환
const transformChannelForSidebar = (channel) => {
    const dbStatus = channel.status;       // DB: ASSIGNED, LIVE, SUSPENDED, ENDED
    const sessionIdx = channel.sessionIdx; // DB: SESSION_IDX (연결된 세션, null이면 미연결)

    let displayStatus;
    if (dbStatus === "LIVE") displayStatus = "LIVE";
    else if (dbStatus === "SUSPENDED") displayStatus = "SUSPENDED";
    else if (dbStatus === "ENDED") displayStatus = "ENDED";
    else if (sessionIdx) displayStatus = "RESERVED"; // ASSIGNED + SESSION_IDX 있음
    else displayStatus = "READY";                     // ASSIGNED + SESSION_IDX 없음

    // isTestStreaming: 백엔드 testStreamChannels(ECS 인메모리) 플래그가 가장 정확
    // URL 패턴만으로는 session-use/test-start 모두 같은 URL을 써서 구분 불가
    const consoleEndPoint = channel.consoleEndPoint || "";
    const isTestStreaming = channel.isTestStreaming !== undefined
        ? !!channel.isTestStreaming
        : !!(consoleEndPoint && channel.ncloudChannelId && consoleEndPoint.includes(`/live/video/${channel.ncloudChannelId}/`));

    // 테스트 송출 중이면 실제로 NCloud가 PUBLISHING 상태이므로 LIVE로 표시
    // (mediaCenterSync는 테스트 채널의 DB STATUS를 의도적으로 변경하지 않으므로 프론트에서 덮어씌움)
    if (isTestStreaming) displayStatus = "LIVE";

    return {
        idx: channel.idx,
        channelId: channel.ncloudChannelId,
        channelName: channel.channelName,
        status: displayStatus,
        assignedSessionIdx: sessionIdx || null,
        rtmpUrl: channel.publishUrl || "-",
        streamKey: channel.streamKey || "-",
        endPoint: channel.cdnDomain ? `https://${channel.cdnDomain}` : "-",
        lastSyncAt: channel.lastSyncAt || "-",
        isTestStreaming,
    };
};

const getStreamingStatusLabel = (status) => {
    return STREAMING_STATUS_LABEL[status] || status || "-";
};

const getStreamingStatusClass = (status) => {
    return `status_${(status || "").toLowerCase()}`;
};

const getStreamingStatusColor = (status) => {
    return STREAMING_STATUS_COLOR[status] || "#94A3B8";
};

const copyToClipboard = (value) => {
    if (!value || value == "-") return;
    if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(value);
        return;
    }
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
};

const StreamingDetailField = ({ label, info, children }) => {
    return (
        <div className="streaming_modal2_field media-center-field">
            <h5>
                <span>{label}</span>
                {info ? <span className="media-center-info-icon" title={info}>i</span> : null}
            </h5>
            <div className="streaming_modal2_value">{children}</div>
        </div>
    );
};

const controlPanelShellStyles = css`
    .admin_console {
      position: absolute;
      top: 250px;
      background: #3e3e46;
      box-sizing: border-box;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      transition: all 0.3s;
      z-index: 999;
    }
    .left_console {
      width: 300px;
      left: 0;
      border-radius: 0;
      height: 620px;
      overflow: hidden;
    }
    .right_console {
      width: 260px;
      right: 0;
      border-radius: 8px 0 0 8px;
      height: 220px;
      overflow: hidden;
    }

    .left_console.on .text_container_top,
    .left_console.on .text_container_content {
      display: none;
    }
    .left_console .left_console_folding {
      display: none;
    }
    .left_console.on .left_console_folding {
      display: block;
    }
    .left_console.on {
      width: 42px;
      height: 220px;
      padding: 0;
    }
    .left_console.on .left_console_folding button {
      position: relative;
      display: block;
      width: 42px;
      height: 220px;
    }
    .left_console.on .left_console_folding button .arrow_div {
      position: absolute;
      top: 0;
      left: 0;
      width: 42px;
      height: 42px;
      text-align: center;
    }
    .left_console.on .left_console_folding button .number_div {
      height: calc(100% - 42px);
      width: 42px;
      margin-top: 42px;
    }
    .left_console.on .left_console_folding button img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(180deg);
      width: 12px;
      height: 12px;
      opacity: 0.78;
    }
    .left_console.on .left_console_folding h2 {
      display: inline-block;
      font-size: 13px;
      font-weight: 400;
      color: #fff;
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 0;
      transform: rotate(-90deg);
      white-space: nowrap;
    }

    .text_container_top {
      position: relative;
      display: flex;
      background: #33343d;
      height: 50px;
      text-align: center;
    }
    .text_container_top:after {
      content: "";
      clear: both;
      display: block;
    }
    .text_container_top h2 {
      float: left;
      width: calc(100% - 42px);
      margin: 0;
      font-size: 13px;
      color: #fff;
      line-height: 50px;
      font-weight: 400;
    }
    #firstB {
      position: relative;
      float: left;
      width: 42px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      background: #3e3e46;
      border: 0;
      outline: none;
      padding: 0;
      appearance: none;
    }
    #firstB img,
    #prevB img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 11px;
      height: 11px;
      opacity: 0.78;
    }
    #prevB {
      position: absolute;
      top: 13px;
      right: 18px;
      left: auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      outline: none;
      padding: 0;
      appearance: none;
      z-index: 2;
    }
    #prevB img {
      top: 50%;
      width: 9px;
      height: 9px;
    }
    #prevB:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.14);
    }
    #prevB:focus-visible {
      border-color: rgba(255, 255, 255, 0.2);
    }
    .text_container_content {
      position: relative;
      height: calc(100% - 50px);
    }
    .text_container_content:after {
      content: "";
      clear: both;
      display: block;
    }
    .control_fix_div {
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 14px;
      border-top: 1px solid #1f1f24;
      width: 100%;
      text-align: right;
    }
    .control_fix_div input {
      display: none;
    }
    .control_fix_div label {
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .control_fix_div input + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      box-sizing: border-box;
      background: url(https://cdn.onoffevent.com/common/chk.svg) no-repeat;
      background-size: cover;
    }
    .control_fix_div input:checked + label span {
      background: url(https://cdn.onoffevent.com/common/chk_on.svg) no-repeat;
      background-size: cover;
    }
    .control_list li {
      border-bottom: 0 !important;
    }
    .control_list li img {
      opacity: 0.3;
    }
    .control_list li.on img {
      opacity: 1;
    }
    .control_list li.on a {
      background: transparent;
    }
    .control_list li.on a img {
      opacity: 1;
    }
    .control_list a {
      display: flex;
      align-items: center;
      height: 44px;
      line-height: 44px;
      text-align: center;
      color: #fff !important;
      background: transparent;
      padding: 10px 12px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .control_list a img {
      width: 14px;
      height: 14px;
      object-fit: contain;
      flex: 0 0 14px;
      display: block;
    }
    .control_list a svg {
      width: 14px !important;
      height: 14px !important;
      flex: 0 0 14px;
      display: block;
    }
    .control_list a span {
      font-size: 13px;
      font-weight: 400;
      display: inline-block;
      margin-left: 26px;
    }
    .control_list a.selected {
      background: transparent;
    }
    .control_list a.selected img {
      opacity: 1;
    }
    .control_list.on {
      float: left;
      width: 42px;
    }
    .control_list.on a {
      justify-content: center;
      padding: 0;
    }
    .control_list.on a img {
      margin: 0 auto;
    }
    .control_list.on span {
      display: none;
    }
    .control_list.on .control_list li:last-child {
      border-bottom: 0;
    }

    .control_content {
      position: relative;
      float: left;
      width: calc(100% - 42px);
      background: #33343d;
      height: 100%;
      padding: 10px;
    }
    .control_content.none {
      display: none;
    }
    .control_content .top_title {
      margin-bottom: 6px;
    }
    .control_content .top_title span {
      font-size: 12px;
      padding: 5px 0 0 10px;
      display: block;
      color: #5e5e61;
    }

    .control_content_list {
      margin-bottom: 15px;
    }
    .control_content_list li {
      border-radius: 0;
      padding: 10px;
      background: #33343d;
      margin-bottom: 6px;
    }
    .control_content_list li:last-child {
      margin-bottom: 0;
    }
    .control_content_list a {
      display: block;
      margin-bottom: 14px;
      cursor: pointer;
    }
    .control_content_list a span {
      font-size: 12px;
      color: #fff;
      line-height: 1.43;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .control_content_list .control_content_list_tool {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .control_content_list .control_content_list_tool > div {
      display: flex;
      align-items: center;
    }
    .control_content_list .control_content_list_tool > div span {
      display: block;
      font-size: 11px;
      font-weight: 500;
      line-height: 11px;
      color: #5e5e61;
      margin-right: 4px;
    }
    .control_content_list .control_content_list_tool label.switch {
      margin-right: 10px;
    }
    label.switch {
      position: relative;
      width: 34px;
      height: 18px;
      border-radius: 14px;
      background: #202026;
      cursor: pointer;
    }
    label.switch input[type='checkbox'] {
      display: none;
    }
    label.switch span {
      position: relative;
      width: 100%;
      height: 100%;
      display: inline-block;
    }
    label.switch span::before {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #999999;
      border-radius: 14px;
    }
    label.switch span::after {
      content: '';
      position: absolute;
      display: block;
      width: 12px;
      height: 12px;
      background-color: #fff;
      border-radius: 50%;
      top: 50%;
      left: 4px;
      transform: translateY(-50%);
      transition: left .3s ease;
      box-shadow: 0 2px 4px 0 rgb(90 90 90 / 50%);
    }
    label.switch input:checked ~ span::before {
      border: 1px solid #7758fa;
      background-color: #7758fa;
    }
    label.switch input:checked ~ span::after {
      left: 18px;
    }
    .control_content_list .control_content_list_tool .on_off_exporsure {
      cursor: auto;
    }
    .control_content_list .control_content_list_tool .on_off_exporsure strong {
      display: block;
      padding: 1px 10px;
      font-size: 8px;
      font-weight: bold;
      text-align: left;
      color: #7758fa;
      border-radius: 14px;
      border: solid 1px #7758fa;
    }
    .control_content_list .control_content_list_tool .on_off_exporsure strong.off {
      color: #5e5e61;
      border: solid 1px #5e5e61;
    }
    .live_captions_content_list li.selected {
      border: 1px solid var(--color-brand-primary);
    }
    .live_captions_detail {
      max-height: calc(100vh - 340px);
      overflow-y: auto;
      padding-right: 4px;
    }
    .live_captions_detail::-webkit-scrollbar {
      width: 4px;
    }
    .live_captions_detail::-webkit-scrollbar-thumb {
      background: rgb(91 92 104);
      border-radius: 999px;
    }
    .live_captions_item_description {
      margin: -8px 0 14px;
      font-size: 11px;
      line-height: 1.45;
      color: var(--color-text-muted);
      word-break: keep-all;
    }
    .live_captions_detail .connect_way_div_inner {
      justify-content: flex-end;
      gap: 6px;
    }
    .live_captions_detail > div li h5 {
      color: rgb(156 160 170);
      line-height: 1.35;
      word-break: keep-all;
    }
    .live_captions_feature_toggle li {
      gap: 12px;
    }
    .live_captions_runtime_controls,
    .live_captions_mode_controls {
      display: flex;
      gap: 6px;
      margin: 8px 0;
      flex-wrap: wrap;
    }
    .live_captions_runtime_controls a,
    .live_captions_mode_controls a {
      min-height: 30px;
      padding: 7px 10px;
      border: 1px solid var(--color-brand-primary, rgb(119 88 250));
      border-radius: 4px;
      color: var(--color-white, rgb(255 255 255));
      background: transparent;
      font-size: 12px;
      line-height: 16px;
      cursor: pointer;
    }
    .live_captions_runtime_controls a:hover,
    .live_captions_mode_controls a:hover,
    .live_captions_mode_controls a.selected {
      border-color: var(--color-brand-primary, rgb(119 88 250));
      color: var(--color-brand-primary, rgb(119 88 250));
      font-weight: 700;
    }
    .live_captions_status_list li {
      display: grid !important;
      grid-template-columns: 86px minmax(0, 1fr);
      align-items: start !important;
      gap: 8px;
      min-height: 0;
      padding: 8px 0 !important;
    }
    .live_captions_status_list li div {
      height: auto !important;
      min-width: 0;
      text-align: right;
    }
    .live_captions_status_list li div span {
      display: block;
      color: var(--color-white, rgb(255 255 255));
      font-size: 11px;
      line-height: 1.45;
      white-space: normal;
      word-break: keep-all;
      overflow-wrap: anywhere;
    }
    .live_captions_runtime_stream {
      margin-top: 12px;
      padding: 10px;
      border: 1px solid rgb(76 77 88);
      border-radius: 6px;
      background: rgb(44 45 54);
      max-height: 156px;
      overflow-y: auto;
    }
    .live_captions_runtime_stream::-webkit-scrollbar {
      width: 4px;
    }
    .live_captions_runtime_stream::-webkit-scrollbar-thumb {
      background: rgb(91 92 104);
      border-radius: 999px;
    }
    .live_captions_runtime_stream h5 {
      margin-bottom: 8px;
      color: var(--color-white, rgb(255 255 255));
      font-size: 12px;
      font-weight: 700;
    }
    .live_captions_runtime_stream ul {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .live_captions_runtime_stream li {
      display: grid;
      grid-template-columns: 44px 1fr;
      gap: 4px 8px;
      color: var(--color-white, rgb(255 255 255));
    }
    .live_captions_runtime_stream strong,
    .live_captions_runtime_stream span {
      font-size: 11px;
      line-height: 16px;
    }
    .live_captions_runtime_stream p {
      grid-column: 1 / -1;
      color: rgb(214 216 224);
      font-size: 11px;
      line-height: 16px;
      word-break: keep-all;
    }

    .control_content_detail {
      position: relative;
      float: left;
      width: calc(100% - 42px);
      background: #33343d;
      height: 100%;
      padding: 10px;
      z-index: 999;
    }
    .control_content_detail > div {
      border-radius: 0;
      background-color: #33343d;
      margin-bottom: 6px;
    }
    .control_content_detail > div:first-child {
      padding: 10px;
    }
    .control_content_detail > div h4 {
      font-size: 12px;
      line-height: 1.5;
      color: #fff;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .control_content_detail > div li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid #000;
    }
    .control_content_detail > div li:last-child {
      border-bottom: 0;
      cursor: pointer;
    }
    .control_content_detail > div li div {
      height: 18px;
    }
    .control_content_detail > div li div a {
      display: block;
      width: 18px;
      height: 18px;
      text-align: center;
    }
    .control_content_detail > div li div span {
      font-size: 11px;
      font-weight: 500;
      line-height: 1.82;
      color: #fff;
    }
    .control_content_detail > div li h5 {
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #5e5e61;
    }
    .control_content_detail .connect_way_div_inner {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .control_content_detail .connect_way_div input {
      display: none;
    }
    .control_content_detail .connect_way_div input[type="radio"] + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
      box-sizing: border-box;
      background: url("https://cdn.onoffevent.com/common/form_radio_off.svg");
      cursor: pointer;
    }
    .control_content_detail .connect_way_div input[type="radio"]:checked + label span {
      background: url("https://cdn.onoffevent.com/common/form_radio_on.svg");
      cursor: pointer;
    }
    .control_content_detail .connect_way_div label {
      display: flex;
      align-items: center;
      font-size: 11px;
      color: #fff;
      margin-right: 10px;
    }
    .control_content_detail .connect_way_div label:last-child {
      margin-right: 0;
    }
    .control_content_detail .progress_complete input {
      display: none;
    }
    .control_content_detail .progress_complete input + label {
      display: flex;
      align-items: center;
      font-size: 11px;
      font-weight: 500;
      color: #fff;
      cursor: pointer;
    }
    .control_content_detail .progress_complete input + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 4px;
      box-sizing: border-box;
      background: url("https://cdn.onoffevent.com/common/chk.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
    }
    .control_content_detail .progress_complete input:checked + label span {
      background: url("https://cdn.onoffevent.com/common/chk_on.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
    }
    .control_content_detail > div li.survey_edit h5 {
      font-size: 12px;
      font-weight: 500;
      color: #7758fa;
    }
    .streaming_channel_table {
      width: 100%;
      border-collapse: collapse;
    }
    .streaming_channel_table th,
    .streaming_channel_table td {
      border-bottom: 1px solid #2f2f35;
      padding: 8px 6px;
      font-size: 11px;
      text-align: left;
      color: #fff;
      vertical-align: middle;
    }
    .streaming_channel_table th {
      color: #8b8b90;
      font-weight: 500;
    }
    .exit_content {
      padding: 10px;
      border-radius: 0;
      background-color: #33343d;
    }
    .exit_content ul li {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .exit_content ul li div {
      height: 18px;
    }
    .exit_content ul li h5 {
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #5e5e61;
    }
    .admin_console_top {
      display: flex;
      justify-content: left;
      align-items: center;
      background: #3b3b3f;
    }
    .admin_console_top h2 {
      font-size: 15px;
      color: #fff;
      margin: 0 auto;
    }
    .admin_console_top button {
      width: 50px;
      height: 50px;
    }
    .right_console button {
      width: 50px;
      height: 50px;
      transform: rotate(180deg);
      transition: all 0.3s;
    }
    .right_console.on button {
      transform: rotate(0deg);
    }
    .right_console_content {
      padding: 20px 20px 10px 20px;
    }
    .right_console_content p {
      font-size: 15px;
      color: #fff;
      font-weight: normal;
      margin-bottom: 5px;
    }
    .right_console_content span {
      font-size: 40px;
      font-weight: 900;
      color: #9898fc;
      line-height: 1.6;
      cursor: pointer;
      text-decoration: underline;
    }
    .right_console .right_console_folding {
      display: none;
    }
    .right_console.on {
      width: 50px;
      height: 220px;
      padding: 0;
    }
    .right_console.on .right_console_folding {
      display: block;
      inline-size: inherit;
      box-sizing: border-box;
      font-size: 0;
    }
    .right_console .right_console_folding button {
      position: relative;
      height: 220px;
      z-index: 999999;
    }
    .right_console .right_console_folding button .arrow_div {
      position: absolute;
      top: 0;
      left: 50%;
      width: 50px;
      height: 50px;
      transform: translateX(-50%);
    }
    .right_console .right_console_folding button .number_div {
      position: relative;
      height: calc(100% - 50px);
      margin-top: 50px;
    }
    .right_console .right_console_folding button img {
      position: absolute;
      top: 15px;
      left: 50%;
      transform: translate(-50%);
    }
    .right_console.on .right_console_folding h2 {
      font-size: 15px;
      font-weight: 900;
      display: inline-block;
      color: #fff;
      position: absolute;
      bottom: 35%;
      left: 0;
      width: 50px;
      transform: rotate(-90deg);
      white-space: nowrap;
    }
    .right_console.on .right_console_folding span {
      font-size: 16px;
      display: inline-block;
      font-weight: 900;
      text-align: left;
      color: #9898fc;
      transform: rotate(-90deg);
      width: 46px;
      position: absolute;
      top: 14%;
      left: 0;
      text-align: center;
    }
    .right_console.on .admin_console_top,
    .right_console.on .right_console_content {
      display: none;
    }
    .right_console.on .admin_console_top h2 {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) rotate(180deg);
      writing-mode: vertical-lr;
    }
`;

export default (props) => {
    const { 
        modalShow
        ,showPopup
        ,consoleCfg
        ,setSurveyPageNum
        ,showConnectUsersViewModal
        ,setShowConnectUsersViewModal
        ,panelConfig = CONTROL_PANEL_CONFIGS.typeA
    } = props;
    
   
    return (
        <Fragment>
           <SideBar consoleCfg={consoleCfg} setSurveyPageNum={setSurveyPageNum} modalShow={modalShow} showPopup={showPopup} showConnectUsersViewModal={showConnectUsersViewModal} setShowConnectUsersViewModal={setShowConnectUsersViewModal} panelConfig={panelConfig} />
        </Fragment>
    );
};

const SideBar = (props) => {
    const { modalShow, showPopup, consoleCfg, panelConfig = CONTROL_PANEL_CONFIGS.typeA } = props;
    const { setSurveyPageNum, showConnectUsersViewModal, setShowConnectUsersViewModal } = props;
    const { siteInfo } = useStore();
    const { iam } = useContext(AppContext);
    const messages = panelConfig?.messages || CONTROL_PANEL_CONFIGS.typeA.messages;
    const surveyTypeLabel = (type) => messages?.surveyTypeLabel?.[type] || type || "-";
    const isCaptionsPocEnabled = !!panelConfig?.features?.captionsPoc;
    
    const [ step,setStep ] = useState(0);
    const [ sessionInfo,setSessionInfo ] = useState({});
    const [ selectSurvey, setSelectSurvey ] = useState();
    const [ selectModal, setSelectModal ] = useState();

    const [ consoleOpenClose, setConsoleOpenClose ] = useState(false);
    const [ consoleOpenClose2, setConsoleOpenClose2 ] = useState(false);
    const [ leftMenu, setLeftMenu ] = useState('');
    const [ beforeSurvey, setBeforeSurvey ] = useState([]);
    const [ progressSurvey, setProgressSurvey ] = useState([]);
    const [ afterSurvey, setAfterSurvey ] = useState([]);
    const [ modalPopup, setModalPopup ] = useState([]);

    // 세션 참가 체크
    const [connectUserLength,setConnectUserLength] = useState(0);
    const [ checkedRealTimeIdx, setCheckedRealTimeIdx ] = useState(0);
    const [ checkedModalPopupIdx, setCheckedModalPopupIdx ] = useState(0);
    const [ isSendProc, setIsSendProc ] = useState(false);
    const [ exvalue, setExvalue ] = useState(consoleCfg?.exitPopupUseYn ?? 'N');
    const [ exitPopupOpenValue, setExitPopupOpenValue ] = useState(consoleCfg?.exitPopupOpenUseYn ?? 'N');
    const [ selectedStreamingChannel, setSelectedStreamingChannel ] = useState(null);
    const [ streamingChannelItems, setStreamingChannelItems ] = useState([]);
    const [ showStreamingDetailModal, setShowStreamingDetailModal ] = useState(false);
    const [ showStreamingAllChannelsModal, setShowStreamingAllChannelsModal ] = useState(false);
    const [ streamingActionAnchorEl, setStreamingActionAnchorEl ] = useState(null);
    const [ streamingActionMenuChannelId, setStreamingActionMenuChannelId ] = useState("");
    const [ streamingStatusFilter, setStreamingStatusFilter ] = useState("ALL");
    const [ streamingSearchKeyword, setStreamingSearchKeyword ] = useState("");
    const [ streamingDetailTab, setStreamingDetailTab ] = useState("INFO");
    const [ pendingToggleOffChannel, setPendingToggleOffChannel ] = useState(null);
    const [ pendingToggleSwitchChannel, setPendingToggleSwitchChannel ] = useState(null); // { newItem, prevChannel }
    const [ recordingAutoImportEnabled, setRecordingAutoImportEnabled ] = useState(true);
    const [ copiedStreamingField, setCopiedStreamingField ] = useState("");
    const [ streamingReloadTrigger, setStreamingReloadTrigger ] = useState(0);
    const [ testStreamingChannelId, setTestStreamingChannelId ] = useState(null);
    const [ isTestStreamConnecting, setIsTestStreamConnecting ] = useState(false);
    const testStreamPollRef = useRef(null); // HLS 폴링 취소 토큰
    const copyFeedbackTimerRef = useRef(null);
    // 페이지 리로드/이탈(beforeunload·pagehide) 진행 중 여부.
    // WS 순간 끊김으로 페이지가 리로드되면 진행 중이던 요청이 중단되는데,
    // 이때 실제 저장 실패가 아니므로 "저장 실패" 헛경고를 띄우지 않기 위함.
    const isUnloadingRef = useRef(false);

    const currentSessionIdx = Number(consoleCfg?.sessionIdx);
    const testStreamLsKey = `testStream_${currentSessionIdx}`;
    // 현재 세션에 연결된 채널 (RESERVED or LIVE) → 토글 OFF 가능
    const isCurrentSessionChannel = (item) => {
        return (item?.status == "RESERVED" || item?.status == "LIVE")
            && Number(item?.assignedSessionIdx) === currentSessionIdx;
    };
    const isReservedByCurrentSession = (item) => {
        return item?.status == "RESERVED" && Number(item?.assignedSessionIdx) === currentSessionIdx;
    };
    const isDetailViewableChannel = (item) => {
        return !!item?.channelId;
    };
    // READY 또는 LIVE인데 아직 세션 미연결 → 토글 ON 가능
    const isSelectableChannel = (item) => {
        if (item?.status == "READY") return true;
        if (item?.status == "LIVE" && !item?.assignedSessionIdx) return true;
        return false;
    };

    const streamingChannels = streamingChannelItems.map((item) => {
        if (isCurrentSessionChannel(item)) {
            return {
                ...item,
                assignedSessionName: sessionInfo?.title || messages.currentSession,
            };
        }
        return item;
    });
    const selectableStreamingChannels = streamingChannels.filter((item) => {
        return isSelectableChannel(item);
    });
    const filteredAllChannels = streamingChannels.filter((item) => {
        const isStatusMatched = streamingStatusFilter == "ALL" ? true : item.status == streamingStatusFilter;
        const keyword = (streamingSearchKeyword || "").trim().toLowerCase();
        const isKeywordMatched = keyword.length == 0
            ? true
            : (item.channelName || "").toLowerCase().includes(keyword) || (item.channelId || "").toLowerCase().includes(keyword);
        return isStatusMatched && isKeywordMatched;
    });
    const actionMenuChannel = streamingChannels.find((item) => item.channelId == streamingActionMenuChannelId) || null;
    const isActionMenuOpen = Boolean(streamingActionAnchorEl) && Boolean(actionMenuChannel);

    const selectedStreamingUsageHistory = selectedStreamingChannel ? [
        {
            eventType: selectedStreamingChannel.status || "-",
            eventDetailType: "CHANNEL_SYNC",
            eventDetail: `${selectedStreamingChannel.channelId} ${messages.channelSyncDetailSuffix}`,
            occurredAt: selectedStreamingChannel.lastSyncAt || "-",
        },
    ] : [];
    
    const loadSueveys = () => {
        const req = {
            path: "/v1/event/session/surveys/lists",
            data: {
                eventIdx : consoleCfg.eventIdx,
                sessionIdx : consoleCfg.sessionIdx
            },
        };
         _API.post(req).then((res) => {
            setBeforeSurvey(res.data?.before)
            setProgressSurvey(res.data?.progress)
            setAfterSurvey(res.data?.after)
        });
    }

    const loadModalPopup = () => {
        const req = {
            path: "/v1/event/session/surveys/modal/popup",
            data: {
                eventIdx : consoleCfg.eventIdx,
                sessionIdx : consoleCfg.sessionIdx
            },
        };
         _API.post(req).then((res) => {
            setModalPopup(res.data?.data)
        });
    }

    const applyRealtimeExposureState = (state = {}) => {
        const activeSurveyIdx = Number(state?.activeSurveyIdx) || 0;
        const activePopupIdx = Number(state?.activePopupIdx) || 0;
        setCheckedRealTimeIdx(activeSurveyIdx);
        setCheckedModalPopupIdx(activePopupIdx);
    };

    const loadRealtimeExposureState = () => {
        if (!consoleCfg?.eventIdx || !consoleCfg?.sessionIdx) return;
        const req = {
            path: "/v1/event/session/realtime/state/find",
            isNoErrorNotify: true,
            data: {
                eventIdx: consoleCfg.eventIdx,
                sessionIdx: consoleCfg.sessionIdx,
            },
        };
        _API.post(req).then((res) => {
            applyRealtimeExposureState(res.data);
        }).catch(() => {});
    };

    const showRealtimeStateSaveError = () => {
        swal({ title: "Notice", text: "실시간 노출 상태 저장에 실패했습니다. 다시 시도해 주세요." });
    };

    // 토글 저장 실패 알림 가드.
    // 서버가 실제로 거부(HTTP 4xx/5xx 또는 data.error !== 0)한 경우에만 경고를 띄운다.
    // 페이지 리로드/이탈이나 WS 순간 끊김으로 요청이 중단된(전송계층) 경우는
    // 실제 저장 실패가 아니므로(서버는 200 저장됐을 수 있음) 헛경고를 띄우지 않는다.
    const notifyRealtimeStateSaveError = (err) => {
        if (isUnloadingRef.current) return; // 페이지 이탈 중 → 무시
        const isServerRejection =
            err?.error !== undefined ||           // _API: data.error !== 0 → 서버 거부
            (err?.response && err.response.status >= 400); // HTTP 에러 응답
        if (isServerRejection) {
            showRealtimeStateSaveError();
        }
        // 그 외(Network Error/취소/중단)는 낙관적 UI가 이미 원복되었으므로 조용히 무시
    };

    const saveRealtimeExposureState = async (type, idx) => {
        const req = {
            path: "/v1/event/session/realtime/state",
            isNoErrorNotify: true,
            data: {
                eventIdx: consoleCfg.eventIdx,
                sessionIdx: consoleCfg.sessionIdx,
                type,
                idx,
            },
        };
        const res = await _API.post(req);
        applyRealtimeExposureState(res.data);
        return res.data;
    };

    const loadSession = () => {
        const req = {
            path: "/v1/event/session/surveys/session",
            data: {
                eventIdx : consoleCfg.eventIdx,
                sessionIdx : consoleCfg.sessionIdx
            },
        };
         _API.post(req).then((res) => {
            setSessionInfo(res.data?.session)
        });
    }

    const loadStreamingChannels = () => {
        // snapshot(hasConsoleSession) 대신 쿠키(getAuth)로 게이트한다. F5 시 snapshot 동기화 타이밍보다
        // 먼저 호출돼도 쿠키만 있으면 라이브 채널을 로드한다(권한은 서버가 판정). (라이브채널 사라짐 방지)
        if (!siteInfo?.siteIdx || !_CK.getAuth()) return;
        _API.post({
            path: "/v1/media-center/channels",
            data: { context: "rail", siteIdx: siteInfo.siteIdx },
        }).then((res) => {
            const channels = res.data?.data || [];
            const transformed = channels.map(transformChannelForSidebar);
            setStreamingChannelItems(transformed);

            // 테스트 송출 상태 복원 (서버 JOIN → localStorage 순으로 폴백)
            const testStreamChannel = transformed.find(ch => ch.isTestStreaming);
            if (testStreamChannel) {
                setTestStreamingChannelId(testStreamChannel.channelId);
                localStorage.setItem(testStreamLsKey, testStreamChannel.channelId);
            } else {
                const savedChannelId = localStorage.getItem(testStreamLsKey);
                if (savedChannelId && transformed.find(ch => ch.channelId === savedChannelId)) {
                    setTestStreamingChannelId(savedChannelId);
                } else if (savedChannelId) {
                    localStorage.removeItem(testStreamLsKey); // 채널이 목록에 없으면 정리
                }
            }

            // 현재 세션 채널 자동 선택 (선택된 채널 없을 때만)
            const currentSessionIdx = Number(consoleCfg?.sessionIdx);
            if (currentSessionIdx) {
                setSelectedStreamingChannel(prev => {
                    if (prev?.channelId) return prev;
                    const sessionChannel = transformed.find(ch =>
                        Number(ch.assignedSessionIdx) === currentSessionIdx
                    );
                    return sessionChannel || prev;
                });
            }
        }).catch(() => {});
    };
   
    const rightConsoleShow = (show) =>{
        setConsoleOpenClose(show);
      }
    const leftConsoleShow = (show) =>{
    setConsoleOpenClose2(show);
    }
    
    const backStep = ()=>{
        if(step ==1){
            setStep(0);
            setLeftMenu('');
        }else if(step==2){
            setStep(1);
        }
    }
    const onSetLeftMenu = (value) =>{
        setStep(1);
        setLeftMenu(value);
        if (value == "STREAMING" && !selectedStreamingChannel && selectableStreamingChannels.length > 0) {
            setSelectedStreamingChannel(selectableStreamingChannels[0]);
        }
    }
    
    const onCheckChange = (e,item) => {
        const { name } = e.target;
        if (name == 'surveyOpen') {
            const check = e.target.checked;
            const prevSurveyIdx = checkedRealTimeIdx;
            const nextSurveyIdx = check ? item.idx : 0;
            saveRealtimeExposureState("survey", nextSurveyIdx).then(() => {
                onSend && onSend(check ? "SURVEY_OPEN" : "SURVEY_CLOSE", item);
            }).catch((err) => {
                setCheckedRealTimeIdx(prevSurveyIdx);
                notifyRealtimeStateSaveError(err);
            });
        } else if (name == 'modalPopupOpen') {
            const check = e.target.checked;
            const prevModalPopupIdx = checkedModalPopupIdx;
            const nextModalPopupIdx = check ? item.idx : 0;
            saveRealtimeExposureState("popup", nextModalPopupIdx).then(() => {
                onSend && onSend(check ? "MODAL_POPUP_OPEN" : "MODAL_POPUP_CLOSE", item);
            }).catch((err) => {
                setCheckedModalPopupIdx(prevModalPopupIdx);
                notifyRealtimeStateSaveError(err);
            });
        } else if (name == 'exitPopup') { 
            const exitPopupUseYn = e.target.value === 'Y' ? 'N' : 'Y';
            setExvalue(exitPopupUseYn);
            onChangeExitPopupUseYn(exitPopupUseYn);
        } else if (name == 'exitPopupOpen') { 
            const exitPopupOpenUseYn = e.target.value === 'Y' ? 'N' : 'Y';
            setExitPopupOpenValue(exitPopupOpenUseYn);
            onChangeExitPopupOpenUseYn(exitPopupOpenUseYn);
        }         
    };

    const onChangeExitPopupUseYn = (exitPopupUseYn) => {
        const item = {exitPopupUseYn : exitPopupUseYn}
        const req = {
            path: "/v1/client/console/exitPopup/save",
            data: {
                eventIdx: consoleCfg?.eventIdx,
                sessionIdx: consoleCfg?.sessionIdx,
                modId: iam?.idx,
                exitPopupUseYn,
            }
        };
      
        _API.post(req).then((res) => {
            const { data, status } = res;
            if (status === 'SUCCESS') {
                alert(messages.exitPopupSaved);
                onSend && onSend("EXIT_SETTING", item);
            } else {
                alert(messages.exitPopupSaveFailed);
            }
        });
    }

    const onChangeExitPopupOpenUseYn = (exitPopupOpenUseYn) => {
        const item = {value : exitPopupOpenUseYn}
        onSend && onSend("ATTEND_EXIT_POPUP", item);
    }

    const onSelectSurvey = (e, survey) => {
        var onT = $(".control_list li.on a span").text();
        $(".text_container_top h2").text(onT);
        $(".control_content_detail").hide();
        setSurveyPageNum(2);
        setSelectSurvey(survey);
        setStep(2);
    }

    const onSelectModal = (e, item) => {
        var onT = $(".control_list li.on a span").text();
        $(".text_container_top h2").text(onT);
        $(".control_content_detail").hide();
        setSelectModal(item);
        setStep(2)
    }

    const onSelectStreamingChannel = (e, item) => {
        const isViewableChannel = isDetailViewableChannel(item);
        if (!isViewableChannel) {
            return;
        }
        var onT = $(".control_list li.on a span").text();
        $(".text_container_top h2").text(onT);
        $(".control_content_detail").hide();
        setSelectedStreamingChannel(item);
        setStep(2);
    }

    const onSelectLiveCaptionFeature = (e) => {
        var onT = $(".control_list li.on a span").text();
        $(".text_container_top h2").text(onT);
        $(".control_content_detail").hide();
        setStep(2);
    }

    const onOpenStreamingChannelInfo = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        const isViewableChannel = isDetailViewableChannel(item);
        if (!isViewableChannel) {
            return;
        }
        setSelectedStreamingChannel(item);
        setStreamingDetailTab("INFO");
        setShowStreamingDetailModal(true);
    }

    const onOpenStreamingChannelInfoFromAllChannels = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedStreamingChannel(item);
        setStreamingDetailTab("INFO");
        setShowStreamingAllChannelsModal(false);
        setShowStreamingDetailModal(true);
    }

    const onToggleStreamingChannel = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        const checked = e.target.checked;

        if (checked) {
            // Toggle ON: READY → RESERVED (세션 연결)
            if (!isSelectableChannel(item)) return;
            // 테스트 송출 중인 채널은 라이브 연결 차단
            if (testStreamingChannelId === item.channelId) return;

            // 현재 세션에 이미 연결된 다른 채널 탐색
            const prevSessionChannel = streamingChannelItems.find(
                (ch) => ch.channelId !== item.channelId && isCurrentSessionChannel(ch)
            ) || null;

            // prevSessionChannel이 LIVE 송출 중이면 확인 모달 표시 (테스트 송출 중인 채널은 제외 - doAssign에서 자동 종료)
            if (prevSessionChannel?.status === "LIVE" && testStreamingChannelId !== prevSessionChannel?.channelId) {
                setRecordingAutoImportEnabled(true);
                setPendingToggleSwitchChannel({ newItem: item, prevChannel: prevSessionChannel });
                return;
            }

            // 낙관적 업데이트: 기존 채널 해제 + 새 채널 연결
            const nextStatusOn = item.status === "LIVE" ? "LIVE" : "RESERVED";
            const prevIsTestStreaming = prevSessionChannel && testStreamingChannelId === prevSessionChannel.channelId;
            setStreamingChannelItems((prev) => prev.map((ch) => {
                if (ch.channelId === item.channelId) {
                    return { ...ch, status: nextStatusOn, assignedSessionIdx: currentSessionIdx };
                }
                if (prevSessionChannel && ch.channelId === prevSessionChannel.channelId) {
                    // 테스트 송출 채널: 세션 해제 → READY (테스트 송출 오버라이드 해제 + 세션 없음)
                    // 일반 LIVE 채널: LIVE 유지하되 세션 해제
                    const releaseStatus = (ch.status === "LIVE" && !prevIsTestStreaming) ? "LIVE" : "READY";
                    return { ...ch, status: releaseStatus, isTestStreaming: false, assignedSessionIdx: null };
                }
                return ch;
            }));
            setSelectedStreamingChannel({ ...item, status: nextStatusOn, assignedSessionIdx: currentSessionIdx });

            const doAssign = () => {
                // 다른 채널에서 테스트 송출 중이면 먼저 종료
                const activeTestChannelId = testStreamingChannelId && testStreamingChannelId !== item.channelId ? testStreamingChannelId : null;
                if (activeTestChannelId) {
                    setTestStreamingChannelId(null);
                    localStorage.removeItem(testStreamLsKey);
                    _API.post({
                        path: "/v1/media-center/channels/test-stop",
                        data: { context: "rail", siteIdx: siteInfo?.siteIdx, channelId: activeTestChannelId, sessionIdx: currentSessionIdx },
                    }).then(() => {
                        onSend && onSend("TEST_STREAM_OFFLINE", { channelId: activeTestChannelId });
                    });
                }

                _API.post({
                    path: "/v1/media-center/channels/session-use",
                    isNoErrorNotify: true,
                    data: {
                        channelId: item.channelId,
                        sessionIdx: currentSessionIdx,
                        eventIdx: consoleCfg?.eventIdx,
                        context: "rail",
                        siteIdx: siteInfo?.siteIdx,
                    },
                }).then(() => {
                    onSend && onSend("STREAM_ONLINE", { channelId: item.channelId });
                    if (prevSessionChannel) {
                        onSend && onSend("STREAM_OFFLINE", { channelId: prevSessionChannel.channelId });
                    }
                }).catch(() => {
                    // 실패 시 원래 상태로 복원
                    setStreamingChannelItems((prev) => prev.map((ch) => {
                        if (ch.channelId === item.channelId) {
                            return { ...ch, status: item.status, assignedSessionIdx: item.assignedSessionIdx };
                        }
                        if (prevSessionChannel && ch.channelId === prevSessionChannel.channelId) {
                            return { ...ch, status: prevSessionChannel.status, assignedSessionIdx: prevSessionChannel.assignedSessionIdx };
                        }
                        return ch;
                    }));
                    setSelectedStreamingChannel(item);
                    loadStreamingChannels();
                });
            };

            if (prevSessionChannel) {
                _API.post({
                    path: "/v1/media-center/channels/session-release",
                    data: { context: "rail", siteIdx: siteInfo?.siteIdx, channelId: prevSessionChannel.channelId },
                }).then(() => {
                    doAssign();
                }).catch(() => {
                    // 해제 실패 시 원래 상태로 복원
                    setStreamingChannelItems((prev) => prev.map((ch) => {
                        if (ch.channelId === item.channelId) {
                            return { ...ch, status: item.status, assignedSessionIdx: item.assignedSessionIdx };
                        }
                        if (ch.channelId === prevSessionChannel.channelId) {
                            return { ...ch, status: prevSessionChannel.status, assignedSessionIdx: prevSessionChannel.assignedSessionIdx };
                        }
                        return ch;
                    }));
                    setSelectedStreamingChannel(prevSessionChannel);
                    loadStreamingChannels();
                });
            } else {
                doAssign();
            }
        } else {
            // Toggle OFF: 현재 세션 채널(RESERVED or LIVE) → 세션 해제
            if (!isCurrentSessionChannel(item)) return;

            // LIVE 송출 중이면 확인 모달 표시 (테스트 송출 중인 채널은 doToggleOff에서 자동 종료)
            if (item.status === "LIVE" && testStreamingChannelId !== item.channelId) {
                setRecordingAutoImportEnabled(true);
                setPendingToggleOffChannel(item);
                return;
            }

            doToggleOff(item);
        }
    }

    const onToggleSelectedStreamingTest = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        const checked = e.target.checked;
        const channel = item || selectedStreamingChannel;
        if (!channel?.channelId) return;

        if (checked) {
            setTestStreamingChannelId(channel.channelId);
            setIsTestStreamConnecting(true);
            localStorage.setItem(testStreamLsKey, channel.channelId);
            _API.post({
                path: "/v1/media-center/channels/test-start",
                data: {
                    channelId: channel.channelId,
                    sessionIdx: currentSessionIdx,
                    context: "rail",
                    siteIdx: siteInfo?.siteIdx,
                },
            }).then(() => {
                // TEST_STREAM_ONLINE: consoleCfg 갱신 트리거 (STREAM_ONLINE과 달리 채널 상태 변경 없음)
                onSend && onSend("TEST_STREAM_ONLINE", { channelId: channel.channelId });

                // API 응답 후에도 HLS 세그먼트가 준비될 때까지 시간이 걸림 → 폴링으로 확인
                const hlsUrl = channel.endPoint && channel.endPoint !== '-'
                    ? `${channel.endPoint}/live/video/${channel.channelId}/playlist.m3u8`
                    : null;

                if (!hlsUrl) {
                    setIsTestStreamConnecting(false);
                    return;
                }

                const pollId = Symbol();
                testStreamPollRef.current = pollId;

                const MAX_WAIT_MS = 30000;
                const POLL_INTERVAL_MS = 2000;
                const startTime = Date.now();

                const poll = () => {
                    if (testStreamPollRef.current !== pollId) return; // 취소됨 (OFF 또는 재시작)
                    if (Date.now() - startTime > MAX_WAIT_MS) {
                        setIsTestStreamConnecting(false);
                        return;
                    }
                    fetch(hlsUrl, { method: 'HEAD' })
                        .then(res => {
                            if (testStreamPollRef.current !== pollId) return;
                            if (res.ok) {
                                setIsTestStreamConnecting(false);
                            } else {
                                setTimeout(poll, POLL_INTERVAL_MS);
                            }
                        })
                        .catch(() => {
                            if (testStreamPollRef.current !== pollId) return;
                            setTimeout(poll, POLL_INTERVAL_MS);
                        });
                };
                setTimeout(poll, POLL_INTERVAL_MS);
            }).catch(() => {
                testStreamPollRef.current = null;
                setIsTestStreamConnecting(false);
                setTestStreamingChannelId(null);
                localStorage.removeItem(testStreamLsKey);
            });
        } else {
            testStreamPollRef.current = null; // 진행 중인 폴링 취소
            setIsTestStreamConnecting(false);
            setTestStreamingChannelId(null);
            localStorage.removeItem(testStreamLsKey);
            // 낙관적 업데이트: isTestStreaming=true로 인해 "LIVE"였던 status를 즉시 원래 상태로 복원
            // (sessionIdx 있으면 RESERVED, 없으면 READY) → 리로드 전까지 올바른 badge 표시
            setStreamingChannelItems(prev => prev.map(ch => {
                if (ch.channelId !== channel.channelId) return ch;
                const revertedStatus = ch.assignedSessionIdx ? "RESERVED" : "READY";
                return { ...ch, status: revertedStatus, isTestStreaming: false };
            }));
            _API.post({
                path: "/v1/media-center/channels/test-stop",
                data: {
                    channelId: channel.channelId,
                    sessionIdx: currentSessionIdx,
                    context: "rail",
                    siteIdx: siteInfo?.siteIdx,
                },
            }).then(() => {
                onSend && onSend("TEST_STREAM_OFFLINE", { channelId: channel.channelId });
            }).catch(() => {
                setTestStreamingChannelId(channel.channelId);
                localStorage.setItem(testStreamLsKey, channel.channelId);
                // 실패 시 원래 LIVE 상태로 복원
                setStreamingChannelItems(prev => prev.map(ch => {
                    if (ch.channelId !== channel.channelId) return ch;
                    return { ...ch, status: "LIVE", isTestStreaming: true };
                }));
            });
        }
    };

    const buildRecordingDecision = (source, enabled) => ({
        recordingAutoImportEnabled: !!enabled,
        recordingSaveDecisionSource: source,
    });

    const doSwitchChannel = (newItem, prevChannel, recordingDecision = null) => {
        if (!newItem?.channelId || !prevChannel?.channelId) return;

        // 낙관적 업데이트
        const nextStatusOn = newItem.status === "LIVE" ? "LIVE" : "RESERVED";
        setStreamingChannelItems((prev) => prev.map((ch) => {
            if (ch.channelId === newItem.channelId) {
                return { ...ch, status: nextStatusOn, assignedSessionIdx: currentSessionIdx };
            }
            if (ch.channelId === prevChannel.channelId) {
                return { ...ch, status: "LIVE", assignedSessionIdx: null };
            }
            return ch;
        }));
        setSelectedStreamingChannel({ ...newItem, status: nextStatusOn, assignedSessionIdx: currentSessionIdx });

        const doAssign = () => {
            _API.post({
                path: "/v1/media-center/channels/session-use",
                isNoErrorNotify: true,
                data: {
                    channelId: newItem.channelId,
                    sessionIdx: currentSessionIdx,
                    eventIdx: consoleCfg?.eventIdx,
                    context: "rail",
                    siteIdx: siteInfo?.siteIdx,
                },
            }).then(() => {
                onSend && onSend("STREAM_ONLINE", { channelId: newItem.channelId });
                onSend && onSend("STREAM_OFFLINE", { channelId: prevChannel.channelId });
            }).catch(() => {
                setStreamingChannelItems((prev) => prev.map((ch) => {
                    if (ch.channelId === newItem.channelId) {
                        return { ...ch, status: newItem.status, assignedSessionIdx: newItem.assignedSessionIdx };
                    }
                    if (ch.channelId === prevChannel.channelId) {
                        return { ...ch, status: prevChannel.status, assignedSessionIdx: prevChannel.assignedSessionIdx };
                    }
                    return ch;
                }));
                setSelectedStreamingChannel(newItem);
                loadStreamingChannels();
            });
        };

        _API.post({
            path: "/v1/media-center/channels/session-release",
            data: {
                context: "rail",
                siteIdx: siteInfo?.siteIdx,
                channelId: prevChannel.channelId,
                ...(recordingDecision || {}),
            },
        }).then(() => {
            doAssign();
        }).catch(() => {
            setStreamingChannelItems((prev) => prev.map((ch) => {
                if (ch.channelId === newItem.channelId) {
                    return { ...ch, status: newItem.status, assignedSessionIdx: newItem.assignedSessionIdx };
                }
                if (ch.channelId === prevChannel.channelId) {
                    return { ...ch, status: prevChannel.status, assignedSessionIdx: prevChannel.assignedSessionIdx };
                }
                return ch;
            }));
            setSelectedStreamingChannel(prevChannel);
            loadStreamingChannels();
        });
    };

    const doToggleOff = (item, recordingDecision = null) => {
        // 테스트 송출 중인 채널을 해제하면 테스트 송출 먼저 자동 중단
        if (testStreamingChannelId === item.channelId) {
            testStreamPollRef.current = null;
            setIsTestStreamConnecting(false);
            setTestStreamingChannelId(null);
            localStorage.removeItem(testStreamLsKey);
            _API.post({
                path: "/v1/media-center/channels/test-stop",
                data: { context: "rail", siteIdx: siteInfo?.siteIdx, channelId: item.channelId, sessionIdx: currentSessionIdx },
            }).then(() => {
                onSend && onSend("TEST_STREAM_OFFLINE", { channelId: item.channelId });
            });
        }

        // 낙관적 업데이트: API 전 즉시 UI 반영
        const nextStatusOff = item.status === "LIVE" ? "LIVE" : "READY";
        setStreamingChannelItems((prev) => prev.map((ch) => {
            if (ch.channelId !== item.channelId) return ch;
            return { ...ch, status: nextStatusOff, assignedSessionIdx: null };
        }));
        if (selectedStreamingChannel?.channelId === item.channelId) {
            setSelectedStreamingChannel(null);
        }

        _API.post({
            path: "/v1/media-center/channels/session-release",
            data: {
                context: "rail",
                siteIdx: siteInfo?.siteIdx,
                channelId: item.channelId,
                ...(recordingDecision || {}),
            },
        }).then(() => {
            onSend && onSend("STREAM_OFFLINE", { channelId: item.channelId });
        }).catch(() => {
            // 실패 시 원래 상태로 복원
            setStreamingChannelItems((prev) => prev.map((ch) => {
                if (ch.channelId !== item.channelId) return ch;
                return { ...ch, status: item.status, assignedSessionIdx: item.assignedSessionIdx };
            }));
            setSelectedStreamingChannel(item);
            alert(messages.releaseChannelFailed);
        });
    }

    const onCopyStreamingField = (fieldKey, value) => {
        if (!value || value == "-") return;
        copyToClipboard(value);
        setCopiedStreamingField(fieldKey);
        if (copyFeedbackTimerRef.current) {
            clearTimeout(copyFeedbackTimerRef.current);
        }
        copyFeedbackTimerRef.current = setTimeout(() => {
            setCopiedStreamingField("");
        }, 1500);
    };

    const onToggleStreamingActionMenu = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        if (streamingActionMenuChannelId == item.channelId && streamingActionAnchorEl) {
            setStreamingActionAnchorEl(null);
            setStreamingActionMenuChannelId("");
            return;
        }
        setStreamingActionAnchorEl(e.currentTarget);
        setStreamingActionMenuChannelId(item.channelId);
    };

    const onCloseStreamingActionMenu = () => {
        setStreamingActionAnchorEl(null);
        setStreamingActionMenuChannelId("");
    };

    const onReleaseReservedChannel = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        if (!item || item?.status != "RESERVED") return;

        _API.post({
            path: "/v1/media-center/channels/session-release",
            data: { context: "rail", siteIdx: siteInfo?.siteIdx, channelId: item.channelId },
        }).then(() => {
            setStreamingChannelItems((prev) => prev.map((streamingItem) => {
                if (streamingItem.channelId != item.channelId) return streamingItem;
                return {
                    ...streamingItem,
                    status: "READY",
                    assignedSessionIdx: null,
                    assignedSessionName: "-",
                };
            }));
            setSelectedStreamingChannel((prev) => {
                if (prev?.channelId != item.channelId) return prev;
                return {
                    ...prev,
                    status: "READY",
                    assignedSessionIdx: null,
                    assignedSessionName: "-",
                };
            });
            onCloseStreamingActionMenu();
        }).catch(() => {
            alert(messages.releaseChannelFailed);
            onCloseStreamingActionMenu();
        });
    };

    //SOCKET SEND
    const onSend = (cate,more,checked) => {
        if (isSendProc) {
            return;
        }
        let param = {
            mode: cate,
            siteIdx: siteInfo?.siteIdx,
            eventIdx: consoleCfg?.eventIdx,
            sessionIdx: consoleCfg?.sessionIdx,
            consoleIdx: consoleCfg?.consoleIdx,
            name: iam?.name,
            memType: iam?.memType,
            companyName: iam?.companyName,
            deptName: iam?.deptName,
            memberIdx: iam?.idx,
            checked: checked,
        }
        if(more){
            param = {...param,...more};
        }
        if(cate){
            setIsSendProc(true);
            _U.postMessage("SOCKET-SEND", {
                action: cate,
                data: param,
            });
            setIsSendProc(false);
        }
    };

    // 🎯 초기 실시간 참가자 수 로드 (connectUserLength 초기화)
    // 실패 시 5초 후 1회 재시도 (네트워크 일시 오류 / API 일시 실패 대비)
    // isNoErrorNotify: 백그라운드 폴링이므로 swal alert 차단 (인증 race 시 사용자 노이즈 방지)
    const loadInitialConnectUserCount = (isRetry = false) => {
        const isAdmin = _R.isSystemAdmin(iam?.memberRoles) || _R.isOrgAdmin(iam?.memberRoles);
        if (!isAdmin || !siteInfo?.siteIdx || !consoleCfg?.eventIdx || !consoleCfg?.sessionIdx) {
            return;
        }
        if (!_CK.getAuth()) {
            return;
        }
        const req = {
            path: "/v1/client/console/user/list",
            isNoErrorNotify: true,
            data: {
                siteIdx: siteInfo?.siteIdx,
                eventIdx: consoleCfg?.eventIdx,
                sessionIdx: consoleCfg?.sessionIdx,
                consoleIdx: consoleCfg?.consoleIdx,
            },
        };
        _API.post(req).then((res) => {
            setConnectUserLength(res.data?.length || 0);
        }).catch((err) => {
            console.error('[ConnectUserCount] Initial load failed:', err?.message || err);
            if (!isRetry) {
                setTimeout(() => loadInitialConnectUserCount(true), 5000);
            }
        });
    };

    //SOCKET RECIEVE
    const onReceivedMessage = (e) => {
        _U.parseMessage(e).then((data) => {
            switch (data.code) {
                case "SOCKET-RECEIVED":
                    return data.data ? JSON.parse(data.data) : null;
            }
        }).then((data) => {
            // WS 재연결: 끊긴 동안 놓친 실시간 노출 상태/목록을 재동기화한다.
            // (없으면 stale 상태로 토글 → 서버가 "현재 진행 서베이/팝업 아님"으로 거부 → 저장 실패)
            if(data?.mode == 'SOCKET_RECONNECTED'){
                loadSueveys();
                loadModalPopup();
                loadRealtimeExposureState();
            }
            if(data?.mode == 'SURVEY_OPEN'){
                setCheckedRealTimeIdx(data?.idx)
                setCheckedModalPopupIdx(0)
            }
            if(data?.mode == 'SURVEY_CLOSE'){
                setCheckedRealTimeIdx(0)
            }
            if(data?.mode == 'MODAL_POPUP_OPEN'){
                setCheckedModalPopupIdx(data?.idx)
                setCheckedRealTimeIdx(0)
            }
            if(data?.mode == 'MODAL_POPUP_CLOSE'){
                setCheckedModalPopupIdx(0)
            }
            if(data?.mode == 'CONN_DISCONN'){
                const isAdmin = _R.isSystemAdmin(iam?.memberRoles) || _R.isOrgAdmin(iam?.memberRoles);
                if(isAdmin){
                    setConnectUserLength(data?.data);
                }
            }
            if(data?.mode == 'ATTEND_EXIT_POPUP'){
                setExitPopupOpenValue(data.value);
            }
            if(data?.mode == 'EXIT_SETTING'){
                setExvalue(data.exitPopupUseYn);
            }
            if(data?.mode == 'STREAM_ONLINE' && data?.channelId){
                // 낙관적 업데이트로 이미 반영된 경우 동일 참조 반환 → React re-render 스킵
                setStreamingChannelItems(prev => {
                    let changed = false;
                    const next = prev.map(ch => {
                        if (ch.channelId !== data.channelId) return ch;
                        const nextStatus = ch.status === "LIVE" ? "LIVE" : "RESERVED";
                        if (ch.status === nextStatus && ch.assignedSessionIdx == data.sessionIdx) return ch;
                        changed = true;
                        return { ...ch, status: nextStatus, assignedSessionIdx: data.sessionIdx };
                    });
                    return changed ? next : prev;
                });
            }
            if(data?.mode == 'STREAM_OFFLINE' && data?.channelId){
                // 낙관적 업데이트로 이미 반영된 경우 동일 참조 반환 → React re-render 스킵
                setStreamingChannelItems(prev => {
                    let changed = false;
                    const next = prev.map(ch => {
                        if (ch.channelId !== data.channelId) return ch;
                        const nextStatus = ch.status === "LIVE" ? "LIVE" : "READY";
                        if (ch.status === nextStatus && !ch.assignedSessionIdx) return ch;
                        changed = true;
                        return { ...ch, status: nextStatus, assignedSessionIdx: null };
                    });
                    return changed ? next : prev;
                });
            }
            // 테스트 송출 토글 실시간 동기화 (같은 세션의 다른 관리자가 토글했을 때만 업데이트)
            // NCloud 실제 방송 상태 변경 (mediaCenterSync 감지) → 채널 목록 즉시 갱신
            if(data?.mode == 'CHANNEL_STATUS_CHANGE'){
                setStreamingReloadTrigger(prev => prev + 1);
            }
            if(data?.mode == 'TEST_STREAM_ONLINE' && data?.channelId){
                // 다른 세션의 테스트 송출 이벤트는 무시 (세션 간 테스트 송출 상태 오염 방지)
                if (String(data.sessionIdx) === String(currentSessionIdx)) {
                    setTestStreamingChannelId(data.channelId);
                    localStorage.setItem(testStreamLsKey, data.channelId);
                }
                // 채널 목록 즉시 갱신: isTestStreaming 플래그 및 NCloud 상태 동기화
                setStreamingReloadTrigger(prev => prev + 1);
            }
            if(data?.mode == 'TEST_STREAM_OFFLINE' && data?.channelId){
                // OFFLINE은 channelId 기준으로 처리 (다른 세션에서 종료시켜도 내 상태 정리)
                setTestStreamingChannelId(prev => prev === data.channelId ? null : prev);
                if(localStorage.getItem(testStreamLsKey) === data.channelId){
                    localStorage.removeItem(testStreamLsKey);
                }
                // 채널 목록 즉시 갱신 + NCloud가 PUBLISHING 종료할 때까지 추가 폴링
                setStreamingReloadTrigger(prev => prev + 1);
                setTimeout(() => setStreamingReloadTrigger(prev => prev + 1), 8000);
                setTimeout(() => setStreamingReloadTrigger(prev => prev + 1), 16000);
            }
        });
    };
    useEffect(() => {
        window.addEventListener("message", onReceivedMessage);
        return () => {
            window.removeEventListener("message", onReceivedMessage);
        };
    }, [iam]);

    // 페이지 리로드/이탈 감지: 이탈 중 중단된 요청을 실패로 오인한 헛경고 방지
    useEffect(() => {
        const markUnloading = () => { isUnloadingRef.current = true; };
        window.addEventListener("beforeunload", markUnloading);
        window.addEventListener("pagehide", markUnloading);
        return () => {
            window.removeEventListener("beforeunload", markUnloading);
            window.removeEventListener("pagehide", markUnloading);
        };
    }, []);

    useEffect(() => {
        loadSession();
        loadSueveys();
        loadModalPopup();
        loadRealtimeExposureState();
    }, []);

    // iam + consoleCfg + siteInfo 모두 준비된 후 초기 참가자 수 로드 + CONNECT 트리거
    // deps에 sessionIdx, memberRoles 포함 — 늦게 채워지는 케이스에서도 재트리거되도록
    const iamLoadedRef = useRef(false);
    useEffect(() => {
        if (iam && consoleCfg?.eventIdx && consoleCfg?.sessionIdx && siteInfo?.siteIdx) {
            loadInitialConnectUserCount();
            // CONNECT 트리거: 서버가 connections() 호출 → CONN_DISCONN 브로드캐스트
            // (IAM 케이스는 connections()를 호출하지 않음, CONNECT 케이스만 호출)
            if (!iamLoadedRef.current) {
                iamLoadedRef.current = true;
                setTimeout(() => {
                    _U.postMessage("SOCKET-SEND", {
                        action: "CONNECT",
                        data: {
                            mode: "CONNECT",
                            eventIdx: consoleCfg?.eventIdx,
                            sessionIdx: consoleCfg?.sessionIdx,
                            consoleIdx: consoleCfg?.consoleIdx,
                            memberIdx: iam?.idx,
                        },
                    });
                }, 1000);
            }
        }
    }, [iam?.idx, iam?.memberRoles, consoleCfg?.eventIdx, consoleCfg?.sessionIdx, siteInfo?.siteIdx]);

    // 탭/창 복귀 시 카운트 재로드 (백그라운드 중 stale 가능)
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                loadInitialConnectUserCount();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [iam?.idx, iam?.memberRoles, consoleCfg?.eventIdx, consoleCfg?.sessionIdx, siteInfo?.siteIdx]);

    // 관리자만 30초 폴링 — 외부 이벤트(connect/disconnect/visibility) 없어도 수렴 보장
    // 참가자에게는 폴링 안 걸림 (isAdmin 가드). 관리자 수 10명 기준 분당 ~20회 호출 = 부담 미미.
    useEffect(() => {
        const isAdmin = _R.isSystemAdmin(iam?.memberRoles) || _R.isOrgAdmin(iam?.memberRoles);
        if (!isAdmin || !consoleCfg?.eventIdx || !consoleCfg?.sessionIdx || !siteInfo?.siteIdx) {
            return;
        }
        const intervalId = setInterval(() => {
            loadInitialConnectUserCount();
        }, 30000);
        return () => clearInterval(intervalId);
    }, [iam?.idx, iam?.memberRoles, consoleCfg?.eventIdx, consoleCfg?.sessionIdx, siteInfo?.siteIdx]);

    useEffect(() => {
        loadStreamingChannels();
    }, [siteInfo?.siteIdx]);

    // STREAM_ONLINE/OFFLINE WebSocket 수신 시 채널 목록 새로고침 (stale closure 방지용 trigger)
    useEffect(() => {
        if (streamingReloadTrigger > 0) {
            loadStreamingChannels();
        }
    }, [streamingReloadTrigger]);

    useEffect(() => {
        const selectedChannelId = selectedStreamingChannel?.channelId;
        const selectedFromList = selectedChannelId ? streamingChannels.find((item) => item.channelId == selectedChannelId) : null;
        // 상세 조회는 모든 채널에서 허용하므로, 목록에 존재하는 한 선택을 유지한다.
        if (!selectedFromList || !isDetailViewableChannel(selectedFromList)) {
            setSelectedStreamingChannel(selectableStreamingChannels[0] || null);
        }
    }, [selectedStreamingChannel, selectableStreamingChannels, streamingChannels]);

    useEffect(() => {
        return () => {
            if (copyFeedbackTimerRef.current) {
                clearTimeout(copyFeedbackTimerRef.current);
            }
        };
    }, []);


    const isSelectedStreamingStarted = !!selectedStreamingChannel && testStreamingChannelId === selectedStreamingChannel?.channelId;
    // 실제 방송 중인 채널: LIVE 상태이고 우리가 테스트 송출로 추적하고 있지 않은 경우
    // testStreamingChannelId(실시간 React 상태)를 기준으로 판단 - DB STATUS는 NCloud sync 지연으로 부정확할 수 있음
    const isRealLiveChannel = selectedStreamingChannel?.status === 'LIVE'
        && testStreamingChannelId !== selectedStreamingChannel?.channelId;
    // 현재 세션에서 다른 채널이 이미 LIVE 송출 중인 경우 → 테스트 차단 (END_POINT 덮어쓰기 방지)
    const hasOtherActiveLive = streamingChannelItems.some(ch =>
        ch.channelId !== selectedStreamingChannel?.channelId &&
        isCurrentSessionChannel(ch) &&
        ch.status === 'LIVE'
    );
    // 테스트 송출은 현재 세션에 할당된 채널만 ON/OFF 가능
    const isSelectedChannelCurrentSession = isCurrentSessionChannel(selectedStreamingChannel);
    const canStartSelectedStreaming = !!selectedStreamingChannel && !!selectedStreamingChannel.channelId && isSelectedChannelCurrentSession && !isSelectedStreamingStarted && !isRealLiveChannel && !hasOtherActiveLive;
    const canStopSelectedStreaming = isSelectedStreamingStarted && isSelectedChannelCurrentSession;
    
    return (
        <Wrapper>
            {_R.isSystemAdmin(iam?.memberRoles) && (
                <div 
                    className={cx({ admin_console: true, left_console: true, on: !consoleOpenClose2 })}
                    style={{zIndex : `${modalShow == true || showPopup == true || showConnectUsersViewModal == true ? "1056" : "999" }`}}
                >
                    <div
                        className="text_container_top"
                        style={{ background: `${step == 1 || step == 2 ? "#33343d" : "#3e3e46"}` }}
                    >
                        <button id="firstB" onClick={(e) => leftConsoleShow(false)}>
                            <img src="https://cdn.onoffevent.com/common/btn-side-left.svg" />
                        </button>
                        {step == 1 || step == 2 ? (
                            <button id="prevB" onClick={(() => backStep())}>
                                <img src="https://cdn.onoffevent.com/common/btn_side_back.svg" />
                            </button>
                        ) : null}
                        <h2
                            style={{
                                textAlign: "left",
                                paddingLeft: `${step == 1 || step == 2 ? "20px" : "10px"}`,
                                paddingRight: `${step == 1 || step == 2 ? "26px" : "12px"}`,
                                boxSizing: "border-box",
                                fontSize: "16px",
                                fontWeight: "700",
                                paddingTop: `${step == 1 || step == 2 ? "16px" : "0"}`,
                                lineHeight: `${step == 1 || step == 2 ? "1" : "50px"}`,
                            }}
                        >
                            {(step == 1 && leftMenu == "SURVEY"|| step == 2 && leftMenu == "SURVEY") ?
                            messages.survey
                            : (step == 1 && leftMenu == "MODAL" || step == 2 && leftMenu == "MODAL") ?
                            messages.consolePopup
                            : (step == 1 && leftMenu == "STREAMING") ?
                            messages.liveChannel
                            : (step == 2 && leftMenu == "STREAMING") ?
                            (selectedStreamingChannel?.channelName || messages.liveChannel)
                            : (step == 1 && leftMenu == "CAPTIONS") ?
                            messages.captionsPoc
                            : (step == 1 && leftMenu == "EXIT" || step == 2 && leftMenu == "EXIT") ?
                            messages.exitPopup
                            : messages.control
                            }
                        </h2>
                    </div>
                    <div className="text_container_content">
                        <ul className={cx({control_list :true , on :step==1 || step==2})}>
                            {consoleCfg?.consoleSurveyYn == 'Y' && (
                                <li className={cx({ on: "SURVEY" == leftMenu })}>
                                    <a data-n="#control_content1"
                                        onClick={(e) => onSetLeftMenu("SURVEY")}
                                        target="_blank"
                                    >
                                        <img
                                            src={adminSurvey}
                                            alt={messages.survey}
                                            title={messages.survey}
                                            style={{ opacity: `${leftMenu=="SURVEY" ? "1":"0.3"}`}}
                                        />
                                        <span>{messages.survey}</span>
                                    </a>
                                </li>
                            )}
                            {sessionInfo && sessionInfo.serviceType == "LIVE" && (
                                <>
                                <li className={cx({ on: "MODAL" == leftMenu })}>
                                    <a data-n="#control_content1"
                                        onClick={(e) => onSetLeftMenu("MODAL")}
                                        target="_blank"
                                    >
                                        <img
                                            src={adminConsole}
                                            alt={messages.consolePopup}
                                            title={messages.consolePopup}
                                            style={{ opacity: `${leftMenu=="MODAL" ? "1":"0.3"}`}}
                                        />
                                        <span>{messages.consolePopup}</span>
                                    </a>
                                </li>
                                <li className={cx({ on: "STREAMING" == leftMenu })}>
                                    <a data-n="#control_content1"
                                        onClick={(e) => onSetLeftMenu("STREAMING")}
                                        target="_blank"
                                    >
                                        <LiveTvOutlinedIcon
                                            titleAccess={messages.liveChannel}
                                            style={{
                                                fontSize: "15px",
                                                color: "#fff",
                                                opacity: `${leftMenu == "STREAMING" ? "1" : "0.3"}`,
                                                display: "block",
                                            }}
                                        />
                                        <span>{messages.liveChannel}</span>
                                    </a>
                                </li>
                                <li className={cx({ on: leftMenu == true })}>
                                    <a data-n="#control_content1"
                                        href={`${_CFG.hubUrl()}/#/event/${consoleCfg.eventIdx}/fms?sessionIdx=${consoleCfg.sessionIdx}&au=${_CK.getAuth()}`}
                                        target="_blank"
                                    >
                                        <img
                                        src={adminFmsMain}
                                        alt={messages.fmsMain}
                                        title={messages.fmsMain}
                                        style={{ opacity: "0.3" }}
                                        />
                                        <span>{messages.fmsMain}</span>
                                    </a>
                                </li>
                                <li className={cx({ on: leftMenu == true })}>
                                    <a data-n="#control_content1"
                                        href={`${_CFG.hubUrl()}/#/event/${consoleCfg.eventIdx}/fms/SendingFms?sessionIdx=${consoleCfg.sessionIdx}&au=${_CK.getAuth()}`}
                                        target="_blank"
                                    >
                                        <img
                                        src={adminFmsBroad}
                                        alt={messages.transmissionFms}
                                        title={messages.transmissionFms}
                                        style={{ opacity: "0.3" }}
                                        />
                                        <span>{messages.transmissionFms}</span>
                                    </a>
                                </li>
                                {consoleCfg?.partiTime == 'E' && (
                                    <li className={cx({ on: "EXIT" == leftMenu })}>
                                        <a data-n="#control_content1"
                                            onClick={(e) => onSetLeftMenu("EXIT")}
                                            target="_blank"
                                        >
                                            <img
                                            src={adminFmsBroad}
                                            alt={messages.exitPopup}
                                            title={messages.exitPopup}
                                            style={{ opacity: `${leftMenu=="EXIT" ? "1":"0.3"}`}}
                                            />
                                            <span>{messages.exitPopup}</span>
                                        </a>
                                    </li>    
                                )}
                            </>
                            )}
                            {isCaptionsPocEnabled && (
                                <li className={cx({ on: "CAPTIONS" == leftMenu })}>
                                    <a data-n="#control_content1"
                                        onClick={(e) => onSetLeftMenu("CAPTIONS")}
                                        target="_blank"
                                    >
                                        <img
                                        src={adminConsole}
                                        alt={messages.captionsPoc}
                                        title={messages.captionsPoc}
                                        />
                                        <span>{messages.captionsPoc}</span>
                                    </a>
                                </li>
                            )}
                            
                        </ul>

                        {/* SURVEY */}
                        {(step == 1 && leftMenu == "SURVEY") &&
                            (<div id="control_content1" className={cx({control_content:true, none: step !== 1})}>
                                <Fragment>
                                {sessionInfo && sessionInfo.serviceType != "LIVE" && (
                                    <>
                                        <div className="top_title">
                                            <span>{messages.afterSurvey}</span>
                                        </div>
                                        <ul className="control_content_list">
                                            {afterSurvey && afterSurvey.map((item, i) => {
                                                return (
                                                    <li key={i}>
                                                        <a onClick={(e) => onSelectSurvey(e,item)}>
                                                            <span>{item.title}</span>
                                                        </a>
                                                    </li>
                                                )        
                                            })}
                                        </ul>
                                    </>
                                    )}
                                    {sessionInfo && sessionInfo.serviceType == "LIVE" && (
                                        <>
                                        <div className="top_title">
                                        <span>{messages.progressSurveyTitle}</span>
                                        </div>
                                        <ul className="control_content_list">
                                            {progressSurvey && progressSurvey.map((item, i) => {
                                                return (
                                                    <li key={i}>
                                                        <a onClick={(e) => onSelectSurvey(e,item)}>
                                                            <span>{item.title}</span>
                                                        </a>
                                                        <div className="control_content_list_tool">
                                                            <div className="on_off_exporsure">
                                                                <span>{messages.realtimeExposure}</span>
                                                                <strong className={cx({off:checkedRealTimeIdx != item.idx})}>{checkedRealTimeIdx === item.idx ? 'ON' : 'OFF'}</strong>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        </>
                                    )}
                                    <div className="top_title">
                                        <span>{messages.beforeSurvey}</span>
                                    </div>
                                    <ul className="control_content_list">
                                    {beforeSurvey && beforeSurvey.map((item, i) => {
                                            return (
                                                <li key={i}>
                                                    <a onClick={(e) => onSelectSurvey(e,item)}>
                                                        <span>{item.title}</span>
                                                    </a>
                                                    <div className="control_content_list_tool">
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </Fragment>
                            </div>)
                        }
                        {(step == 2 && leftMenu == "SURVEY") &&  (
                            <div className="control_content_detail">
                                <div><h4>{selectSurvey?.title}</h4></div>
                                {selectSurvey?.type == "PROGRESS" && (
                                    <div>
                                        <ul>
                                            <li className="survey_exposure">
                                                <h5>{messages.surveyExposure}</h5>
                                                <div className="survey_exposure_inner">
                                                    <label className="switch" style={{marginRight:"0"}}>
                                                        <input
                                                            type="checkbox"
                                                            name="surveyOpen"
                                                            checked={ checkedRealTimeIdx === selectSurvey.idx ? true : false }
                                                            onChange={(e) => { onCheckChange(e,selectSurvey); }}
                                                        />
                                                        <span>
                                                        </span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                                <div>
                                    <ul>
                                        <li>
                                            <h5>{messages.surveyTypeField}</h5>
                                            <div>
                                                <span>{surveyTypeLabel(selectSurvey?.type)}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <h5>{messages.surveyQuestionsField}</h5>
                                            <div className="">
                                                <span>{selectSurvey?.questionCnt}{messages.questionCountSuffix}</span>
                                            </div>
                                        </li>
                                        <li className="survey_edit" onClick={() => window.open(`${_CFG.hubUrl()}/#/event/${consoleCfg.eventIdx}/feedback/survey?au=${_CK.getAuth()}`)}>
                                            <h5>{messages.surveyEdit}</h5>
                                            <div>
                                                <a><img src={surveyArrow }/></a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}

                        {/* MODAL_POPUP */}
                        {(step == 1 && leftMenu == "MODAL") && (
                            <div id="control_content1" className={cx({ control_content: true, none: step !== 1 })}>
                                <Fragment>
                                    <div className="top_title">
                                        <span>{messages.consolePopup}</span>
                                    </div>
                                    <ul className="control_content_list">
                                        {modalPopup && modalPopup.map((item, i) => {
                                            return (
                                                <li key={i}>
                                                    <a onClick={(e) => onSelectModal(e,item)}>
                                                        <span>{item.title}</span>
                                                    </a>
                                                    <div className="control_content_list_tool">
                                                        <div className="on_off_exporsure">
                                                            <span>{messages.realtimeExposure}</span>
                                                            <strong className={cx({off:checkedModalPopupIdx != item.idx})}>{checkedModalPopupIdx === item.idx ? 'ON' : 'OFF'}</strong>
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </Fragment>
                            </div>
                        )}
                        {(step == 2 && leftMenu == "MODAL") && (
                            <div className="control_content_detail">
                                <div><h4>{selectModal?.title}</h4></div>
                                <div>
                                    <ul>
                                        <li className="survey_exposure">
                                            {/* <h5 onClick={()=>{setModalPopupShow(true)}}>팝업</h5> */}
                                            <h5>{messages.consolePopup}</h5>
                                            <div className="survey_exposure_inner">
                                                <label className="switch" style={{marginRight:"0"}}>
                                                    <input
                                                        type="checkbox"
                                                        name="modalPopupOpen"
                                                        checked={checkedModalPopupIdx === selectModal.idx ? true : false}
                                                        onChange={(e) => onCheckChange(e,selectModal)}
                                                    />
                                                    <span></span>
                                                </label>
                                            </div>
                                        </li>
                                        <li className="console_edit" onClick={() => window.open(`${_CFG.hubUrl()}/#/event/${consoleCfg.eventIdx}/feedback/popup?au=${_CK.getAuth()}`)}>
                                            <h5>{messages.consolePopupEdit}</h5>
                                            <div>
                                                <a><img src={consolePopupEdit}/></a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}
                        {/* EXIT_POPUP */}
                        {(step == 1 && leftMenu == "EXIT") && (
                            <div id="control_content1" className={cx({ control_content: true, none: step !== 1 })}>
                                {/* <div className="exit_content">
                                    <ul>
                                        <li className="">
                                            <h5>{messages.exitPopup}</h5>
                                            <div className="">
                                                <label className="switch" style={{marginRight:"0"}}>
                                                    <input
                                                        type="checkbox"
                                                        name="exitPopup"
                                                        value={ exvalue ?? "N" }
                                                        checked={exvalue === 'Y' ? true : false}
                                                        onChange={(e) => { onCheckChange(e); }}
                                                    />
                                                    <span></span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div> */}
                                <div className="exit_content">
                                    <ul>
                                        <li className="">
                                            <h5>{messages.exitPopup}</h5>
                                            <div className="">
                                                <label className="switch" style={{marginRight:"0"}}>
                                                    <input
                                                        type="checkbox"
                                                        name="exitPopupOpen"
                                                        value={ exitPopupOpenValue ?? "N" }
                                                        checked={exitPopupOpenValue === 'Y' ? true : false}
                                                        onChange={(e) => { onCheckChange(e); }}
                                                    />
                                                    <span></span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}
                        {(step == 1 && leftMenu == "CAPTIONS") && (
                            <div id="control_content1" className={cx({ control_content: true, none: step !== 1 })}>
                                <LiveCaptionsPanel
                                    eventIdx={consoleCfg?.eventIdx}
                                    onSelectFeature={onSelectLiveCaptionFeature}
                                    sessionIdx={consoleCfg?.sessionIdx}
                                    siteIdx={siteInfo?.siteIdx}
                                />
                            </div>
                        )}
                        {(step == 2 && leftMenu == "CAPTIONS") && (
                            <div className="control_content_detail">
                                <LiveCaptionsDetail
                                    eventIdx={consoleCfg?.eventIdx}
                                    sessionIdx={consoleCfg?.sessionIdx}
                                    siteIdx={siteInfo?.siteIdx}
                                />
                            </div>
                        )}
                        {(step == 1 && leftMenu == "STREAMING") && (
                            <div id="control_content1" className={cx({ control_content: true, none: step !== 1 })}>
                                <Fragment>
                                    <div className="streaming_top_action">
                                        <button
                                            type="button"
                                            className="streaming_all_channels_text_button"
                                            onClick={() => setShowStreamingAllChannelsModal(true)}
                                        >
                                            {messages.allChannels}
                                        </button>
                                    </div>
                                    <ul className="control_content_list streaming_content_list">
                                        {streamingChannels.length > 0 ? streamingChannels.map((item) => {
                                            const isSelectable = isSelectableChannel(item);
                                            const isThisSessionChannel = isCurrentSessionChannel(item);
                                            const isTestStreamingNow = testStreamingChannelId === item.channelId;
                                            // READY → ON 가능 / 현재 세션(RESERVED or LIVE) → OFF 가능 / 테스트 송출 중 → 불가
                                            const isToggleable = (isSelectable || isThisSessionChannel) && !isTestStreamingNow;
                                            const isToggleChecked = isThisSessionChannel;
                                            const isSelected = selectedStreamingChannel?.channelId == item.channelId;
                                            return (
                                                <LiveChannelListItem
                                                    key={item.channelId}
                                                    item={item}
                                                    isSelected={isSelected}
                                                    isToggleable={isToggleable}
                                                    isToggleChecked={isToggleChecked}
                                                    isTestStreaming={testStreamingChannelId === item.channelId}
                                                    onSelect={(e) => onSelectStreamingChannel(e, item)}
                                                    onToggle={(e) => onToggleStreamingChannel(e, item)}
                                                    onOpenDetail={(e) => onOpenStreamingChannelInfo(e, item)}
                                                    detailLabel={messages.channelDetail}
                                                />
                                            )
                                        }) : (
                                            <li className="streaming_empty_item">
                                                <span>{messages.noAvailableChannels}</span>
                                            </li>
                                        )}
                                    </ul>
                                </Fragment>
                            </div>
                        )}
                        {(step == 2 && leftMenu == "STREAMING") && (
                            <div className="control_content_detail streaming_detail_panel">
                                {selectedStreamingChannel ? (
                                    <Fragment>
                                        <div className="streaming_panel_test_actions">
                                            <span className="streaming_panel_test_label">{messages.testStreaming}</span>
                                            <label className="switch streaming_panel_test_switch">
                                                <input
                                                    type="checkbox"
                                                    checked={isSelectedStreamingStarted}
                                                    disabled={isTestStreamConnecting || (!canStartSelectedStreaming && !canStopSelectedStreaming)}
                                                    onChange={(e) => onToggleSelectedStreamingTest(e, selectedStreamingChannel)}
                                                />
                                                <span />
                                            </label>
                                            <span className={cx("streaming_panel_test_text", {
                                                active: isSelectedStreamingStarted,
                                                connecting: isTestStreamConnecting,
                                            })}>
                                                {isRealLiveChannel ? "실제 방송 중" : isTestStreamConnecting ? "연결중..." : isSelectedStreamingStarted ? messages.started : messages.stopped}
                                            </span>
                                        </div>
                                        <ul className="streaming_detail_list">
                                            <li>
                                                <h5>{messages.channelId}</h5>
                                                <div>
                                                    <span>{selectedStreamingChannel.channelId}</span>
                                                </div>
                                            </li>
                                            <li>
                                                <h5>{messages.status}</h5>
                                                <div>
                                                    <span>{getStreamingStatusLabel(selectedStreamingChannel.status)}</span>
                                                </div>
                                            </li>
                                        <li>
                                            <h5>RTMP URL</h5>
                                            <div className="streaming_value_with_copy">
                                                <span>{selectedStreamingChannel.rtmpUrl}</span>
                                                <button
                                                        type="button"
                                                        className="streaming_inline_copy_button"
                                                        onClick={() => onCopyStreamingField("RTMP_URL", selectedStreamingChannel.rtmpUrl)}
                                                        aria-label={messages.copyRtmpUrl}
                                                    >
                                                        {copiedStreamingField == "RTMP_URL" ? <span className="streaming_inline_copy_done">✓</span> : <img src={iconCopy} alt={messages.copyAlt} />}
                                                    </button>
                                                </div>
                                            </li>
                                        <li>
                                            <h5>Stream Key</h5>
                                            <div className="streaming_value_with_copy">
                                                <span>{selectedStreamingChannel.streamKey}</span>
                                                <button
                                                        type="button"
                                                        className="streaming_inline_copy_button"
                                                        onClick={() => onCopyStreamingField("STREAM_KEY", selectedStreamingChannel.streamKey)}
                                                        aria-label={messages.copyStreamKey}
                                                    >
                                                        {copiedStreamingField == "STREAM_KEY" ? <span className="streaming_inline_copy_done">✓</span> : <img src={iconCopy} alt={messages.copyAlt} />}
                                                    </button>
                                                </div>
                                            </li>
                                        <li>
                                            <h5>Playback URL</h5>
                                            <div className="streaming_value_with_copy">
                                                <span>{selectedStreamingChannel.endPoint}</span>
                                                <button
                                                        type="button"
                                                        className="streaming_inline_copy_button"
                                                        onClick={() => onCopyStreamingField("PLAYBACK_URL", selectedStreamingChannel.endPoint)}
                                                        aria-label={messages.copyPlaybackUrl}
                                                    >
                                                        {copiedStreamingField == "PLAYBACK_URL" ? <span className="streaming_inline_copy_done">✓</span> : <img src={iconCopy} alt={messages.copyAlt} />}
                                                    </button>
                                                </div>
                                            </li>
                                        </ul>
                                    </Fragment>
                                ) : (
                                    <div className="streaming_empty_state">
                                        <span>{messages.selectChannelFirst}</span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>                    
                    <div className="console_folding left_console_folding">
                        <button onClick={(e) => leftConsoleShow(true)}>
                            <div className="arrow_div">
                                    <img
                                        src="https://cdn.onoffevent.com/common/btn-side-left.svg"
                                        alt=""
                                    />
                            </div>
                            <div className="number_div">
                                <span
                                    className="left_console_fold_title"
                                    style={{
                                        display: "inline-block",
                                        fontSize: "13px",
                                        fontWeight: 400,
                                        color: "#fff",
                                        lineHeight: "1",
                                        fontFamily: "\"Noto Sans KR\", \"Apple SD Gothic Neo\", sans-serif",
                                        width: "100%",
                                        position: "absolute",
                                        top: "50%",
                                        left: 0,
                                        transform: "rotate(-90deg)",
                                        whiteSpace: "nowrap",
                                        margin: 0,
                                        textAlign: "center",
                                    }}
                                >
                                    Control
                                </span>
                            </div>
                        </button>
                    </div>
                </div>
            )}
            <div 
                className={cx({ admin_console: true, right_console: true, on: !consoleOpenClose })}
                style={{zIndex : `${modalShow == true || showPopup == true || showConnectUsersViewModal == true ? "1056" : "999" }`}}
            >
                <div className="admin_console_top">
                    <h2>{messages.connectStatus}</h2>
                    <button className="right_console_button" onClick={(e) => rightConsoleShow(false)}>
                    <img
                        src="https://cdn.onoffevent.com/common/btn-side-left.svg"
                    />
                    </button>
                </div>
                <div className="right_console_content">
                    <p>{messages.realtimeParticipants}</p>
                    <span className="underline" onClick={() => setShowConnectUsersViewModal(true)}>
                        {connectUserLength}
                    </span>
                </div>
                <div className="console_folding right_console_folding">
                    <button onClick={(e) => rightConsoleShow(true)}>
                        <div className="arrow_div">        
                            <img
                                src="https://cdn.onoffevent.com/common/btn-side-left.svg"
                                alt=""
                            />
                        </div>
                        <div className="number_div">
                            <span>{connectUserLength}</span>
                            <h2>{messages.connectStatus}</h2>
                        </div>
                    </button>
                </div>
            </div>
            <Modal2Base
                modalId="consoleStreamingToggleOffConfirmModal"
                show={!!pendingToggleOffChannel}
                title={messages.recordingSaveConfirmTitle}
                description={messages.recordingSaveConfirmDescription}
                onClose={() => setPendingToggleOffChannel(null)}
                footerRight={(
                    <div style={{ display: "flex", gap: 8 }}>
                        <Button
                            type="button"
                            className="streaming_modal2_close_button"
                            onClick={() => setPendingToggleOffChannel(null)}
                        >
                            {messages.cancel}
                        </Button>
                        <Button
                            type="button"
                            className="streaming_modal2_close_button"
                            onClick={() => {
                                const ch = pendingToggleOffChannel;
                                setPendingToggleOffChannel(null);
                                doToggleOff(ch, buildRecordingDecision("CONSOLE_LIVE_OFF", false));
                            }}
                        >
                            {messages.recordingSkipAndDeactivate}
                        </Button>
                        <Button
                            type="button"
                            className="streaming_modal2_confirm_button"
                            onClick={() => {
                                const ch = pendingToggleOffChannel;
                                const enabled = recordingAutoImportEnabled;
                                setPendingToggleOffChannel(null);
                                doToggleOff(ch, buildRecordingDecision("CONSOLE_LIVE_OFF", enabled));
                            }}
                        >
                            {messages.recordingSaveAndDeactivate}
                        </Button>
                    </div>
                )}
            >
                <div style={{ fontSize: 14, lineHeight: 1.6 }}>
                    <strong>{pendingToggleOffChannel?.channelName || pendingToggleOffChannel?.channelId}</strong>{" "}
                    {messages.recordingSaveConfirmBody}
                    <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
                        <input
                            type="checkbox"
                            checked={recordingAutoImportEnabled}
                            onChange={(event) => setRecordingAutoImportEnabled(event.target.checked)}
                        />
                        <span>{messages.recordingSaveCheckboxLabel}</span>
                    </label>
                    <p style={{ marginTop: 8, marginBottom: 0 }}>
                        {messages.recordingSaveHelpText}
                    </p>
                </div>
            </Modal2Base>
            <Modal2Base
                modalId="consoleStreamingToggleSwitchConfirmModal"
                show={!!pendingToggleSwitchChannel}
                title={messages.recordingSaveConfirmTitle}
                description={messages.recordingSwitchSaveConfirmDescription}
                onClose={() => setPendingToggleSwitchChannel(null)}
                footerRight={(
                    <div style={{ display: "flex", gap: 8 }}>
                        <Button
                            type="button"
                            className="streaming_modal2_close_button"
                            onClick={() => setPendingToggleSwitchChannel(null)}
                        >
                            {messages.cancel}
                        </Button>
                        <Button
                            type="button"
                            className="streaming_modal2_close_button"
                            onClick={() => {
                                const { newItem, prevChannel } = pendingToggleSwitchChannel;
                                setPendingToggleSwitchChannel(null);
                                doSwitchChannel(newItem, prevChannel, buildRecordingDecision("CONSOLE_LIVE_SWITCH", false));
                            }}
                        >
                            {messages.recordingSkipAndSwitch}
                        </Button>
                        <Button
                            type="button"
                            className="streaming_modal2_confirm_button"
                            onClick={() => {
                                const { newItem, prevChannel } = pendingToggleSwitchChannel;
                                const enabled = recordingAutoImportEnabled;
                                setPendingToggleSwitchChannel(null);
                                doSwitchChannel(newItem, prevChannel, buildRecordingDecision("CONSOLE_LIVE_SWITCH", enabled));
                            }}
                        >
                            {messages.recordingSaveAndSwitch}
                        </Button>
                    </div>
                )}
            >
                <div style={{ fontSize: 14, lineHeight: 1.6 }}>
                    <strong>{pendingToggleSwitchChannel?.prevChannel?.channelName || pendingToggleSwitchChannel?.prevChannel?.channelId}</strong>{" "}
                    → <strong>{pendingToggleSwitchChannel?.newItem?.channelName || pendingToggleSwitchChannel?.newItem?.channelId}</strong><br />
                    {messages.recordingSaveConfirmBody}
                    <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
                        <input
                            type="checkbox"
                            checked={recordingAutoImportEnabled}
                            onChange={(event) => setRecordingAutoImportEnabled(event.target.checked)}
                        />
                        <span>{messages.recordingSaveCheckboxLabel}</span>
                    </label>
                    <p style={{ marginTop: 8, marginBottom: 0 }}>
                        {messages.recordingSaveHelpText}
                    </p>
                </div>
            </Modal2Base>

            {showStreamingDetailModal && selectedStreamingChannel && (
                <Modal2Base
                    modalId="consoleStreamingChannelDetailModal"
                    show={showStreamingDetailModal}
                    title={messages.channelDetail}
                    description={messages.channelDetailDescription}
                    onClose={() => setShowStreamingDetailModal(false)}
                    footerRight={(
                        <button
                            type="button"
                            className="streaming_modal2_close_button"
                            onClick={() => setShowStreamingDetailModal(false)}
                        >
                            {messages.close}
                        </button>
                    )}
                >
                    <div className="streaming_modal2_content">
                        <div className="streaming_modal2_tabs">
                            <button
                                type="button"
                                className={cx("streaming_modal2_tab_button", { active: streamingDetailTab == "INFO" })}
                                onClick={() => setStreamingDetailTab("INFO")}
                            >
                                {messages.basicInfo}
                            </button>
                            <button
                                type="button"
                                className={cx("streaming_modal2_tab_button", { active: streamingDetailTab == "USAGE" })}
                                onClick={() => setStreamingDetailTab("USAGE")}
                            >
                                {messages.usageHistory}
                            </button>
                            {selectedStreamingChannel?.status === "LIVE" && (
                                <button
                                    type="button"
                                    className={cx("streaming_modal2_tab_button", { active: streamingDetailTab == "STREAM_STATUS" })}
                                    onClick={() => setStreamingDetailTab("STREAM_STATUS")}
                                >
                                    Stream Status
                                </button>
                            )}
                        </div>
                        {streamingDetailTab == "INFO" && (
                            <div className="streaming_modal2_sections">
                                <div className="streaming_modal2_section_box media-center-detail-section-box">
                                    <h4>{messages.requiredStreamingInfo}</h4>
                                    <div className="streaming_modal2_grid">
                                        <StreamingDetailField label={messages.channelName}>
                                            {selectedStreamingChannel.channelName || "-"}
                                        </StreamingDetailField>
                                        <StreamingDetailField label={messages.channelId}>
                                            {selectedStreamingChannel.channelId || "-"}
                                        </StreamingDetailField>
                                        <StreamingDetailField label={messages.defaultStreamingUrl}>
                                            <div className="streaming_modal2_value_with_action">
                                                <span>{selectedStreamingChannel.rtmpUrl || "-"}</span>
                                                {selectedStreamingChannel.rtmpUrl ? (
                                                    <button type="button" className="streaming_copy_icon_button" onClick={() => copyToClipboard(selectedStreamingChannel.rtmpUrl)}>
                                                        <img src={iconCopy} alt="copy" />
                                                    </button>
                                                ) : null}
                                            </div>
                                        </StreamingDetailField>
                                        <StreamingDetailField
                                            label={messages.streamKeyMain}
                                            info={messages.streamKeyMainInfo}
                                        >
                                            <div className="streaming_modal2_value_with_action">
                                                <span>{selectedStreamingChannel.streamKey || "-"}</span>
                                                {selectedStreamingChannel.streamKey ? (
                                                    <button type="button" className="streaming_copy_icon_button" onClick={() => copyToClipboard(selectedStreamingChannel.streamKey)}>
                                                        <img src={iconCopy} alt="copy" />
                                                    </button>
                                                ) : null}
                                            </div>
                                        </StreamingDetailField>
                                        <StreamingDetailField label={messages.streamKeyBackup}>-</StreamingDetailField>
                                    </div>
                                </div>
                                <div className="streaming_modal2_section_box media-center-detail-section-box">
                                    <h4>{messages.operationInfo}</h4>
                                    <div className="streaming_modal2_grid">
                                        <StreamingDetailField label={messages.channelCreatedAt}>{selectedStreamingChannel.lastSyncAt || "-"}</StreamingDetailField>
                                        <StreamingDetailField label={messages.channelUsageTime}>{messages.durationZero}</StreamingDetailField>
                                        <StreamingDetailField label={messages.recentStreamingStartedAt}>
                                            {selectedStreamingChannel.status == "LIVE" ? (selectedStreamingChannel.lastSyncAt || "-") : "-"}
                                        </StreamingDetailField>
                                        <StreamingDetailField label={messages.recordingSetting}>{messages.recordingSettingValue}</StreamingDetailField>
                                    </div>
                                </div>
                                <div className="streaming_modal2_section_box media-center-detail-section-box">
                                    <h4>{messages.affiliationInfo}</h4>
                                    <div className="streaming_modal2_grid">
                                        <StreamingDetailField label={messages.siteLabel}>{siteInfo?.name || siteInfo?.siteName || "-"}</StreamingDetailField>
                                        <StreamingDetailField label={messages.organizationLabel}>{siteInfo?.orgName || "-"}</StreamingDetailField>
                                    </div>
                                </div>
                            </div>
                        )}
                        {selectedStreamingChannel?.status === "LIVE" && (
                            <div style={{ display: streamingDetailTab === "STREAM_STATUS" ? "block" : "none" }}>
                                <ConsoleStreamStatusChart
                                    channelId={selectedStreamingChannel?.channelId}
                                    channelName={selectedStreamingChannel?.channelName}
                                    siteIdx={siteInfo?.siteIdx}
                                    isActive={streamingDetailTab === "STREAM_STATUS"}
                                />
                            </div>
                        )}
                        {streamingDetailTab == "USAGE" && (
                            <div className="streaming_modal2_usage">
                                <p>{messages.usageHistoryGuide}</p>
                                <table className="streaming_modal2_usage_table">
                                    <thead>
                                        <tr>
                                            <th>{messages.usageEventType}</th>
                                            <th>{messages.usageEventDetailType}</th>
                                            <th>{messages.usageEventDetail}</th>
                                            <th>{messages.occurredAt}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedStreamingUsageHistory.length > 0 ? selectedStreamingUsageHistory.map((item, index) => {
                                            return (
                                                <tr key={`usage-${index}`}>
                                                    <td>{item.eventType || "-"}</td>
                                                    <td>{item.eventDetailType || "-"}</td>
                                                    <td className="text-left">{item.eventDetail || "-"}</td>
                                                    <td>{item.occurredAt || "-"}</td>
                                                </tr>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="4">{messages.noData}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </Modal2Base>
            )}
            {showStreamingAllChannelsModal && (
                <Modal2Base
                    modalId="consoleStreamingAllChannelsModal"
                    show={showStreamingAllChannelsModal}
                    title={messages.allChannelsTitle}
                    description={messages.allChannelsDescription}
                    onClose={() => setShowStreamingAllChannelsModal(false)}
                    footerRight={(
                        <button
                            type="button"
                            className="streaming_modal2_close_button"
                            onClick={() => setShowStreamingAllChannelsModal(false)}
                        >
                            {messages.close}
                        </button>
                    )}
                >
                    <div className="streaming_all_channels_modal_body">
                        <div className="streaming_all_channels_toolbar">
                            <div className="streaming_all_channels_toolbar_left">
                                <select
                                    className="streaming_all_channels_filter_select"
                                    value={streamingStatusFilter}
                                    onChange={(e) => setStreamingStatusFilter(e.target.value)}
                                >
                                    <option value="ALL">{messages.allStatuses}</option>
                                    <option value="READY">{getStreamingStatusLabel("READY")}</option>
                                    <option value="RESERVED">{getStreamingStatusLabel("RESERVED")}</option>
                                    <option value="LIVE">{getStreamingStatusLabel("LIVE")}</option>
                                    <option value="ENDED">{getStreamingStatusLabel("ENDED")}</option>
                                    <option value="SUSPENDED">{getStreamingStatusLabel("SUSPENDED")}</option>
                                </select>
                            </div>
                            <div className="streaming_all_channels_toolbar_right">
                                <div className="streaming_all_channels_search_wrap">
                                    <SearchIcon />
                                    <input
                                        type="text"
                                        value={streamingSearchKeyword}
                                        onChange={(e) => setStreamingSearchKeyword(e.target.value)}
                                        placeholder={messages.searchChannelsPlaceholder}
                                    />
                                </div>
                            </div>
                        </div>
                        <table className="streaming_all_channels_table">
                            <thead>
                                <tr>
                                    <th>{messages.channelStatusColumn}</th>
                                    <th>{messages.channelNameConsoleColumn}</th>
                                    <th>{messages.channelId}</th>
                                    <th>{messages.channelUsageTimeColumn}</th>
                                    <th>{messages.sessionColumn}</th>
                                    <th>{messages.eventColumn}</th>
                                    <th>{messages.actionColumn}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredAllChannels.length > 0 ? filteredAllChannels.map((item) => {
                                    return (
                                        <tr key={item.channelId}>
                                            <td>
                                                <div className="streaming_table_status_with_dot">
                                                    <span className="status-dot" style={{ backgroundColor: getStreamingStatusColor(item.status) }} />
                                                    <span>{getStreamingStatusLabel(item.status)}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="streaming_all_channel_name_cell">
                                                    <button
                                                        type="button"
                                                        className="streaming_all_channel_name_button"
                                                        onClick={(e) => onOpenStreamingChannelInfoFromAllChannels(e, item)}
                                                    >
                                                        {item.channelName}
                                                    </button>
                                                    {item?.recentConsoleId && item?.recentConsoleUrl ? (
                                                        <a
                                                            className="streaming_all_channel_console_link"
                                                            href={item.recentConsoleUrl}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {messages.openConsoleLink} ({item.recentConsoleId})
                                                        </a>
                                                    ) : (
                                                        <span className="streaming_all_channel_console_link is-empty">-</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>{item.channelId}</td>
                                            <td>{item.usageTime || messages.durationZero}</td>
                                            <td>
                                                <div className="streaming_all_channel_session_cell">
                                                    <span className="streaming_all_channel_session_name">{item.sessionName || "-"}</span>
                                                    <span className="streaming_all_channel_session_datetime">{item.sessionDateTime || "-"}</span>
                                                </div>
                                            </td>
                                            <td>{item.assignedSessionName || "-"}</td>
                                            <td>
                                                {item?.status == "RESERVED" ? (
                                                    <button
                                                        type="button"
                                                        className="streaming_all_channel_action_icon_button"
                                                        onClick={(e) => onToggleStreamingActionMenu(e, item)}
                                                        aria-label={messages.channelActionMenu}
                                                    >
                                                        <MoreHorizIcon />
                                                    </button>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <td colSpan="7" className="streaming_all_channels_empty_row">{messages.noData}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <Menu
                        id="streaming-channel-action-menu"
                        anchorEl={streamingActionAnchorEl}
                        open={isActionMenuOpen}
                        onClose={onCloseStreamingActionMenu}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        PaperProps={{
                            sx: {
                                marginTop: "3px",
                                border: "1px solid #d7d7d7",
                                borderRadius: "4px",
                                boxShadow: "0px 6px 6px rgba(0, 0, 0, 0.08)",
                            },
                        }}
                    >
                        <MenuItem
                            onClick={(e) => onReleaseReservedChannel(e, actionMenuChannel)}
                            disabled={!actionMenuChannel || actionMenuChannel?.status != "RESERVED"}
                            sx={{
                                fontSize: 13,
                                lineHeight: "18px",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                                paddingTop: "7px",
                                paddingBottom: "7px",
                                marginLeft: "8px",
                                marginRight: "8px",
                                borderRadius: "4px",
                                minHeight: "32px",
                                "&:hover": { backgroundColor: "rgba(243, 242, 255, 1)" },
                            }}
                        >
                            {messages.reclaimChannel}
                        </MenuItem>
                    </Menu>
                </Modal2Base>
            )}
        </Wrapper>
    );
};
const Wrapper = styled.div`
    font-family: "Noto Sans KR", "Apple SD Gothic Neo", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    ${controlPanelShellStyles}
    ${controlPanelSharedStyle}
`
